angular.module('galilai.creator').controller('IdeasController', function($scope, layoutService, $timeout, $rootScope, $http, $location, api, $interval, fontsService, topics) {

    // Keyed to source.video_generation in the i18n and to DISABLE_PER_SOURCE in the plans modal
    const VIDEO_UPGRADE_SOURCE = 'video_generation'
    const ENABLE_LOCAL_STORAGE_LOGGEDIN = false
    const GENERATE_POSTS_AFTER_ADDING_PROJECT = false
    const _GENERATE_IMAGES = true
    const AMOUNT_PER_GENERATION = 8
    const MIN_AMOUNT = 5
    const MIN_AMOUNT_VERIFY = 1
    const CHECK_WAIT_POSTS = 40000
    const PROJECTS_ENABLED = true
    const DEFAULT_CONTEXT_TYPE = 'personalized'
    let currentReader = null
    let intervalCheck = null
    let abortController = null
    let itemsGenerated = 0
    let canShowUpdates = true
    let pendingOnboarding = false
    let hasUpdatedInstagramContext = false

    const MAX_RETRIES = 5
    const INTERVAL_INSTAGRAM_MESSAGES = 4000
    const USE_JOB_GENERATION = true
    const JOB_INTERVAL_CHECK = 800
    const SHOW_GENERATE_CALENDAR_AFTER_SIGNUP = false
    const ENABLE_INITIAL_VIEWMODE = false
    let generateRetries = MAX_RETRIES

    const profileMessages = _trans.ideas.profileMessages

    $scope.showProductUpdates = false
    $scope.unifiedView = true
    $scope.basePalletes = buildPalletes()
    $scope.fontFamilies = ALL_GOOGLE_FONTS;

    $scope.pagination = {
        page: 1,
        hasMore: true,
    }

    $scope.onboarding = {
        progress: 0,
        values: {},
        sections: [
            {
                title: gettext('label.guide_overview'),
                tasks: [
                    {
                        id: 'overview',
                        title: gettext('label.guide_overview_title'),
                        description: gettext('label.guide_overview_description'),
                    },
                ]
            },
            {
                title: gettext('label.guide_themes'),
                tasks: [
                    {
                        id: 'persona',
                        title: gettext('label.guide_persona_title'),
                        description: gettext('label.guide_persona_description'),
                    },
                    {
                        id: 'edit-themes',
                        title: gettext('label.guide_themes_title'),
                        description: gettext('label.guide_themes_description'),
                    },
                    {
                        id: 'edit-services',
                        title: gettext('label.guide_services_title'),
                        description: gettext('label.guide_services_description'),
                        optional: true,
                    }
                ]
            },
            {
                title: gettext('label.guide_branding'),
                tasks: [
                    {
                        id: 'branding-colors',
                        title: gettext('label.guide_branding_colors_title'),
                        description: gettext('label.guide_branding_colors_description'),
                        instructionUrl: 'https://www.youtube.com/watch?v=TAFpvXKD_Qk&list=PL5-lev0bfNrQXHi7K6X_iOZWxI7mmiMhR&index=3',
                    },
                    {
                        id: 'branding-logo',
                        optional: true,
                        title: gettext('label.guide_branding_logo_title'),
                        description: gettext('label.guide_branding_logo_description'),
                        instructionUrl: 'https://www.youtube.com/watch?v=iZvrdMJVbcg&list=PL5-lev0bfNrQXHi7K6X_iOZWxI7mmiMhR&index=1'
                    }
                ]
            },
            {
                title: gettext('label.guide_generation'),
                tasks: [
                    {
                        id: 'generation-overview',
                        title: gettext('label.guide_generation_overview_title'),
                        description: gettext('label.guide_generation_overview_description'),
                        instructionUrl: 'https://www.youtube.com/watch?v=i1Rha8bMV3E&list=PL5-lev0bfNrSx2dMuseENTvW6U0I6o_Wb',
                    },
                ]
            },
            {
                title: gettext('label.guide_editing'),
                tasks: [
                    {
                        id: 'editing-overview',
                        title: gettext('label.guide_editing_overview_title'),
                        description: gettext('label.guide_editing_overview_description'),
                        actionUrl: 'https://www.youtube.com/watch?v=u7-KiNTaSPQ&list=PL5-lev0bfNrSx2dMuseENTvW6U0I6o_Wb&index=3',
                    }
                ]
            },
            {
                title: gettext('label.guide_publication'),
                tasks: [
                    {
                        id: 'publication-connect',
                        title: gettext('label.guide_publication_connect_title'),
                        description: gettext('label.guide_publication_connect_description'),
                        actionUrl: 'https://www.youtube.com/watch?v=jTakCvsk8ac',
                    },
                    {
                        id: 'publication-publish',
                        title: gettext('label.guide_publication_post_title'),
                        description: gettext('label.guide_publication_post_description'),
                        actionUrl: 'https://www.youtube.com/watch?v=Qg4fY06IkHc',
                    },
                    {
                        id: 'publication-download',
                        optional: true,
                        title: gettext('label.guide_publication_download_title'),
                        description: gettext('label.guide_publication_download_description'),
                        actionUrl: 'https://www.youtube.com/watch?v=6lpUCdLukag&list=PL5-lev0bfNrTl2-KDVPfN-_NWVBVh-mgK&index=4',
                    }
                ]
            }
        ]
    }

    $scope.dashboard = {
        help: {
            demo: {
                url: 'https://youtu.be/y-DXYYqylfI',
            },
            connect: {
                url: 'https://www.youtube.com/watch?v=jTakCvsk8ac',
            },
            others: [
                {
                    url: 'https://www.youtube.com/watch?v=i1Rha8bMV3E&list=PL5-lev0bfNrSx2dMuseENTvW6U0I6o_Wb',
                    title: gettext('label.guide_generation_overview_title'),
                },
                {
                    url: 'https://www.youtube.com/watch?v=u7-KiNTaSPQ&list=PL5-lev0bfNrSx2dMuseENTvW6U0I6o_Wb&index=3',
                    title: gettext('label.guide_editing_overview_title'),
                },
                {
                    title: gettext('label.guide_publication_connect_title'),
                    url: 'https://www.youtube.com/watch?v=jTakCvsk8ac',
                },
                {
                    url: 'https://www.youtube.com/watch?v=k3xGWltZT0M&list=PL5-lev0bfNrQXHi7K6X_iOZWxI7mmiMhR&index=1',
                    title: gettext('label.guide_branding_colors_title'),
                },
            ]
        }
    }

    let debounceOnboarding = null;
    $scope.updateProgress = function(save) {
        let totalTasks = 0;
        let doneTasks = 0;

        for (const section of $scope.onboarding.sections) {
            for (const task of section.tasks) {
                if (task.optional) {
                    continue;
                }
                totalTasks++;
                if ($scope.onboarding.values[task.id]) {
                    doneTasks++;
                }
            }
        }

        $scope.onboarding.progress = Math.round((doneTasks / totalTasks) * 100);

        if (!$scope?.inputs?.project) {
            return;
        }
        if (typeof save === 'undefined' || save) {
            if (debounceOnboarding) {
                $timeout.cancel(debounceOnboarding);
            }
            debounceOnboarding = $timeout(() => {
                api.updateProjectGlobalSingle($scope.inputs.project, {
                    'onboarding': $scope?.onboarding?.values
                }).then((res) => {
                }).catch((err) => {
                }).finally(() => {
                    debounceOnboarding = null;
                })
            })
        }
    };

    $rootScope.generatorLastMode = null
    try {
        let lastMode = safeGetStorage('generator.lastMode')
        if (lastMode) {
            $rootScope.generatorLastMode = lastMode
        }
    } catch (e) {}

    $scope.doAction = function(task) {
        $rootScope.$broadcast('onboarding.doAction', task);
    }

    // Feature flags for calendar feature
    let USE_CALENDAR_INITIAL = isLoggedIn()
    let showCreateTab = true
    let initialTab = 'create'

    // Logged in always to to calendar
    if (USE_CALENDAR_INITIAL && isLoggedIn()) {
        initialTab = 'dashboard'
    }
    // Enable feature flag
    if (USE_CALENDAR_INITIAL) {
        $rootScope.f.calendar = true
    }
    // Non logged in users do not see create tab
    if (USE_CALENDAR_INITIAL && !isLoggedIn()) {
        showCreateTab = false
    }

    if (isLoggedIn() && $scope.unifiedView) {
        showCreateTab = false
    }

    $rootScope.$on('getCurrentHandle', function(event, data) {
        let handle = $scope?.inputs?.handle

        $rootScope.$emit('onCurrentHandle', {
            handle: handle,
            source: data?.source || null
        })
    })

    $rootScope.$on('onUserData', function(event, args) {
        if (args.features && args.features.calendar) {
            USE_CALENDAR_INITIAL = true
            $rootScope.f.calendar = true
            $timeout(angular.noop)
        }
    })

    $rootScope.$on('showPersona', function(event, args) {
        $scope.changeMainTab('persona')
    })

    $rootScope.$on('changeMainTab', function(event, tab) {
        if (!tab) {
            return
        }
        if ($scope.state.view.mainTab == 'calendar') {
            return
        }
        if ($scope.state.view.mode == tab && $scope.state.view.mainTab == 'calendar') {
            return
        }
        $scope.state.view.mainTab = 'calendar'
        $scope.state.view.mode = tab
    })

    $rootScope.$on('clearRetries', function(event, args) {
        generateRetries = MAX_RETRIES
        $rootScope.postsAmount = 0
    })

    $scope.$watch('state.view.generating', function(newValue, oldValue) {
        $rootScope.generatingIndividualPosts = newValue
    })

    $scope.$watch('state.view.mainTab', function(newValue, oldValue) {
        $rootScope.currentMainTab = newValue
    })

    $scope.$watch('state.view.creatingProject', function(newValue, oldValue) {
        $rootScope.creatingProject = newValue
    })

    $scope.$watch('state.view.input', function(newValue, oldValue) {
        $rootScope.mainShowingInput = newValue
    })

    $scope.$watch('state.view.instagram', function(newValue, oldValue) {
        $rootScope.isViewingInstagram = newValue && $rootScope.mainShowingInput
    })

    $scope.$watch('state.view.mode', function(newValue, oldValue) {
        $rootScope.currentViewMode = newValue
    })

    $rootScope.$on('generator.onNewPosts', function(event, data) {
        if (!data || data.source != 'listView') {
            return
        }
        $scope.loadPosts()
    })

    $rootScope.$on('generate.chooseModes', function(event, data) {
        $scope.showCalendarGenerationModal()
    })

    $scope.dashboardCreate = function() {
        if (!$scope?.state?.data?.global?.designKind) {
            $rootScope.$emit('generator.designKind.show', {
                project: $scope.inputs.project,
                focus: $scope.state.data?.global?.focus
            })
        } else {
            $scope.showCalendarGenerationModal()
        }
    }

    $scope.dashboardCreateLastMode = function() {
        let lastMode = $rootScope.generatorLastMode

        if (!lastMode) {
            return
        }
        if (lastMode == 'empty') {
            $rootScope.$broadcast('generator.startFromScratch')
            return
        }
        if (lastMode == 'postgen') {
            showProfessionalPost()
            return
        }
        $scope.showCalendarGenerationModal(null, lastMode)
    }

    function showProfessionalPost(format) {
        $rootScope.$broadcast('generator.postgen.show', {
            project: $scope.inputs.project,
            theme: $scope.state.data?.theme,
            author: $scope.state.data?.global?.content?.author,
            format: format,
        })
    }

    $scope.showProfessionalPost = function() {
        showProfessionalPost()
    }

    function showVideoModes(mode) {
        // Video is a paid-plan feature: publishing an mp4 needs it, so letting a smaller
        // plan spend credits on a video they cannot publish would be a trap. Upsell here,
        // before the spend, instead of a wall after it.
        if (!$rootScope.isPremiumCustomer()) {
            $rootScope.showUpgrade(VIDEO_UPGRADE_SOURCE)
            return
        }
        $rootScope.$broadcast('generator.postgenvideo.show', {
            project: $scope.inputs.project,
            theme: $scope.state.data?.theme,
            author: $scope.state.data?.global?.content?.author,
            mode: mode,
        })
    }

    // No mode: opens on the mode list. With a mode: skips straight to that mode's form.
    $scope.showProfessionalVideo = function() {
        showVideoModes()
    }

    $scope.showLookalikeVideo = function() {
        showVideoModes('lookalike')
    }

    $rootScope.$on('generator.chooseMode.professional', function(event, data) {
        showProfessionalPost()
    })

    $rootScope.$on('generator.startFromScratch', function(event, data) {
        $scope.startEmpty()
    })

    const suggestedAreas = [
        'medicine',
        'psychology',
        'law',
        'wellness',
        'education',
        'personal_care',
        'cosmetics',
        'fitness',
        'finance',
        'accounting',
        'construction',
        'real_estate',
        'architecture',
        'tech',
        'pets',
        'coaching',
        'clothing',
        'automotive',
        'transport',
        'restaurant',
    ]

    const MAP_AREAS_OBJECTIVE = {
        'medicine': 'authority',
        'psychology': 'authority',
        'law': 'authority',
        'wellness': 'authority',
        'education': 'authority',
        'personal_care': 'authority',
        'cosmetics': 'sales',
        'fitness': 'sales',
        'finance': 'authority',
        'accounting': 'authority',
        'construction': 'sales',
        'real_estate': 'sales',
        'architecture': 'authority',
        'tech': 'authority',
        'pets': 'sales',
        'coaching': 'authority',
        'clothing': 'sales',
        'automotive': 'sales',
        'transport': 'sales',
        'restaurant': 'sales',
    }

    $scope.tmpEditing = null

    $rootScope.getCurrentProjectInfo = function() {
        return getCurrentProjectInfo({
            project: {
                global: $scope?.state?.data?.global,
            },
            social: $scope?.inputs?.social,
            profile: $scope?.inputs?.profile,
        })
    }

    $scope.state = {
        view: {
            showAreas: window.location.search.indexOf('areas') != -1,
            areas: suggestedAreas.map(function(area) {
                return {
                    value: area,
                    label: gettext('area_business.' + area)
                }
            }),
            tabBusiness: 'persona',
            showProjectMenu: false,
            projectSearch: '',
            detailedArea: false,
            instagram: true,
            manualProject: false,
            fullProject: null,
            input: false,
            showInputs: true,
            loggedIn: false,
            generating: false,
            profileMessage: null,
            showColors: false,
            creatingProject: false,
            postsFilter: 'all',
            configTab: 'colors',
            mainTab: initialTab,
            mode: 'calendar',
            showCreateTab: showCreateTab,
            loading: {
                next: false,
                refreshKeywords: false,
            },
            showFontSelection: false,
            projectsEnabled: PROJECTS_ENABLED,
        },
        data: {
            lastSavedConfig: null,
            languages: Object.keys(window._LANGUAGES).map(function(key) {
                return {
                    label: window._LANGUAGES[key],
                    value: key
                }
            }).sort(function(a, b) {
                return a.label.localeCompare(b.label)
            }),
            theme: null,
            fonts: JSON.parse(JSON.stringify(DEFAULT_FONTS)),
            global: null,
            keywords: [],
            selectedMedias: null,
            projects: [
                {
                    name: 'Projeto 1'
                }
            ],
        }
    }

    if (window.location.search.indexOf('areas') != -1) {
        safeSetStorage('galilai.experiment.show-areas', 'B')
    }

    $scope.loginInputs = {}
    $scope.inputs = {
        project: null,
        handle: null,
        profile: null,
        context: null,
        social: null,
        keywords: null,
        area: null,
    }

    $scope.selectedPallete = null
    $scope.posts = []

    $scope.isFirstProject = function() {
        if (!$scope?.inputs?.project) {
            return false
        }
        // Compare the value of inputs.project with the first project in state.data.projects
        if ($scope?.state?.data?.projects && $scope?.state?.data?.projects?.length > 0) {
            return $scope.inputs.project == $scope.state.data.projects[0]._id
        }
        return false
    }

    $scope.isConciergeAvailable = function() {
        return isConciergeAvailable()
    }

    $scope.shouldShowAlertOnboarding = function() {
        return $scope.isFirstProject() && $scope?.onboarding?.progress < 100 && Object.keys($rootScope?.userConfig || {}).length > 0 && $rootScope?.userConfig?.billing?.status != 'active'
    }

    $scope.dismissOfferCard = function() {
        $rootScope.showAnnualOffer = false
        safeSetStorage('galilai.offer.dismissUntil', new Date().getTime() + (1 * 12 * 60 * 60 * 1000)) // 12 hours
    }

    function setupTawk() {
        var Tawk_API = Tawk_API || {};
        let userEmail = localStorage.getItem('auth.user.email')
        let userInstagram = localStorage.getItem('auth.user.instagram')
        let visitor = {}
        if (userEmail) {
            visitor.email = userEmail
        }
        if (userInstagram) {
            visitor.name = userInstagram
        }

        Tawk_API.visitor = visitor
        window.Tawk_API = Tawk_API;

        var Tawk_LoadStart = new Date();
        (function () {
            var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
            s1.async = true;
            s1.src = 'https://embed.tawk.to/65491fb1f2439e1631ec3e46/1heiq7j9a';
            s1.charset = 'UTF-8';
            s1.setAttribute('crossorigin', '*');
            s0.parentNode.insertBefore(s1, s0);
        })();
    }

    $scope.acceptOffer = function() {
        Tawk_API.toggle()
    }

    function formatRemainingTime(ms, maxHours) {
        if (ms <= 0) {
            return "00:00:00";
        }

        const totalSeconds = Math.floor(ms / 1000);
        let hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (maxHours !== undefined && hours > maxHours) {
            hours = maxHours;
        }
        return [
            String(hours).padStart(2, '0') + 'h',
            String(minutes).padStart(2, '0') + 'm',
            String(seconds).padStart(2, '0') + 's'
        ].join(' ');
    }

    $rootScope.$on('loadPosts', function(event, args) {
        $scope.afterLogin()
        // Monitor $rootScope.userConfig until it has keys
        let timer = setInterval(() => {
            if (Object.keys($rootScope.userConfig).length > 0) {

                try {
                    if ($rootScope?.userConfig?.shouldShowOffer?.show) {
                        let dismissUntil = safeGetStorage('galilai.offer.dismissUntil')
                        if (!dismissUntil || new Date().getTime() > parseInt(dismissUntil)) {
                            $rootScope.showAnnualOffer = true
                            localStorage.removeItem('galilai.offer.dismissUntil')

                            let expiresIn = $rootScope?.userConfig?.shouldShowOffer?.expiresIn
                            let interval = $interval(() => {
                                let remaining = expiresIn - new Date().getTime()
                                if (remaining < 0) {
                                    $rootScope.annualOfferExpiration = null
                                    $interval.cancel(interval)
                                    return
                                }
                                $rootScope.annualOfferExpiration = formatRemainingTime(remaining, 12)
                            }, 1000)

                            setupTawk()
                        }
                    }
                } catch (e) {}

                clearInterval(timer)
                if (!canShowUpdates) {
                    return
                }
                if ($rootScope?.userConfig?.showUpdates) {
                    if (!canShowUpdates) {
                        return
                    }
                    $rootScope.showProductUpdates = true

                    var modal = document.getElementById('release-modal');
                    var bsModal = new bootstrap.Modal(modal);
                    modal.addEventListener('hidden.bs.modal', function () {
                        try {
                            if (bsModal) {
                                bsModal.dispose();
                            }
                        } catch (e) {}
                    });
                    setTimeout(() => {
                        if (!canShowUpdates) {
                            return
                        }
                        bsModal.show();

                        if (typeof $rootScope?.userConfig?.showUpdates === 'string') {
                            api.saveConfig({ productUpdate: $rootScope.userConfig.showUpdates}).catch(function() {})
                        }
                    }, 10000);
                }
            }
        }, 500)
    })

    // Resolved from the list rather than from state.view.fullProject, which is null
    // until a project finishes loading and would blank the switcher label.
    $scope.getCurrentProject = function() {
        let projects = $scope.state?.data?.projects || []
        let current = projects.find(function(p) {
            return p._id == $scope.inputs.project
        })
        return current || $scope.state?.view?.fullProject || projects[0] || {}
    }

    // Shortcuts from the business tabs into pickers that already exist. Nothing new
    // is rendered: these open the very same modals the calendar toolbar opens.
    // CalendarController, where the originals live, is a *child* of this scope, so
    // its methods are not reachable from here — hence these openers rather than a
    // direct call.
    function openMediaManager(kind, source) {
        if (!$rootScope.isCustomer(showModal = true, source = source)) {
            return
        }
        $rootScope.$broadcast('media.show', {
            projectId: $scope.inputs.project,
            kind: kind,
            global: $scope.state.data.global,
            multiple: true,
            customAction: 'edit',
        })
        let modal = angular.element('#images-modal')
        if (modal) {
            modal.modal('show')
            modal.css('z-index', 100000)
        }
    }

    $scope.openThemesShortcut = function() {
        if (!$rootScope.isCustomer(showModal = true, source = 'Business Themes')) {
            return
        }
        // Unlike the media pickers, this modal is rendered *inside* the block gated on
        // isMainTabCalendarOrTheme(), so opening it from "Meu negócio" put it inside a
        // hidden ancestor and it came up blank. Switch to the tab that owns it first.
        // The $timeout lets the digest reveal that block before Bootstrap measures and
        // positions the modal, and the tab is put back on close so the shortcut still
        // behaves like a shortcut rather than navigation.
        let previousTab = $scope.state.view.mainTab
        $scope.changeMainTab('theme')
        $timeout(function() {
            let modal = angular.element('#themes-modal')
            modal.one('hidden.bs.modal', function() {
                $scope.$applyAsync(function() {
                    $scope.changeMainTab(previousTab)
                })
            })
            modal.modal('show')
            track('Business Edit Topics')
        })
    }

    $scope.openProductsShortcut = function() {
        openMediaManager('product', 'Business Products')
        track('Business Edit Products')
    }

    $scope.openImagesShortcut = function() {
        openMediaManager('image', 'Business Images')
        track('Business Edit Images')
    }

    $scope.toggleProjectMenu = function($event) {
        if ($event) {
            $event.preventDefault()
            $event.stopPropagation()
        }
        $scope.state.view.showProjectMenu = !$scope.state.view.showProjectMenu
        // A filter left over from the previous visit would hide accounts the user
        // never typed anything to hide, so every open starts from the full list.
        $scope.state.view.projectSearch = ''
        if ($scope.state.view.showProjectMenu) {
            $timeout(function() {
                const input = document.querySelector('[data-ref="project-search-input"]')
                if (input) {
                    input.focus()
                }
            })
        }
    }

    /**
     * Comparator for the account filter, so accents do not hide accounts.
     *
     * Angular's default lowercases both sides and does an indexOf, which leaves "jose"
     * failing to match "José" and "nutricao" failing to match "Nutrição" — on a Brazilian
     * product that is most of the names people type.
     */
    $scope.matchesAccountName = function(actual, expected) {
        if (expected === undefined || expected === null || expected === '') {
            return true
        }
        if (actual === undefined || actual === null) {
            return false
        }
        const plain = function(text) {
            return String(text).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        }
        return plain(actual).indexOf(plain(expected)) !== -1
    }

    // Enter picks the only thing left standing, which is how the field is used:
    // type enough to narrow it down, commit without reaching for the mouse.
    $scope.onProjectSearchKeydown = function($event, filtered) {
        if ($event.key == 'Escape') {
            $scope.state.view.showProjectMenu = false
            return
        }
        if ($event.key == 'Enter' && filtered && filtered.length) {
            $event.preventDefault()
            $scope.selectProject(filtered[0])
            $scope.state.view.showProjectMenu = false
        }
    }

    // There is no click-outside directive in this app, and the other menus only close
    // when an item is picked. A menu that cannot be dismissed is worse than no menu,
    // so this one listens on the document and unregisters with the scope.
    function closeProjectMenuOnOutsideClick(event) {
        if (!$scope.state?.view?.showProjectMenu) {
            return
        }
        if (event.target?.closest && event.target.closest('[data-ref="project-menu"]')) {
            return
        }
        $scope.$applyAsync(function() {
            $scope.state.view.showProjectMenu = false
        })
    }

    document.addEventListener('click', closeProjectMenuOnOutsideClick)
    $scope.$on('$destroy', function() {
        document.removeEventListener('click', closeProjectMenuOnOutsideClick)
    })


    $scope.isConfigEnabled = function(key) {
        if (key == 'generation.automatic.calendar') {
            return $scope.isHighAutomation()
        }
        if (key == 'generation.start_with_instruction') {
            return $scope.isHighAutomation()
        }
        return false
    }

    $scope.isMediumOrLowAuto = function() {
        return $scope?.state?.data?.global?.automation == 'medium' || $scope?.state?.data?.global?.automation == 'low'
    }
    $scope.isHighAutomation = function() {
        return $scope?.state?.data?.global?.automation == 'high' || !$scope?.state?.data?.global?.automation
    }

    $scope.isMediumAutomation = function() {
        return $scope?.state?.data?.global?.automation == 'medium'
    }

    $scope.isLowAutomation = function() {
        return $scope?.state?.data?.global?.automation == 'low'
    }

    $scope.isAuthority = function() {
        return $scope?.state?.data?.global?.focus == 'authority' || !$scope?.state?.data?.global?.focus
    }

    $scope.isSales = function() {
        return $scope?.state?.data?.global?.focus == 'sales'
    }

    $scope.isOfferingPromotional = function() {
        return $scope?.state?.data?.global?.promote === true
    }

    $scope.isOfferingService = function() {
        return $scope?.state?.data?.global?.offeringKind == 'service' || !$scope?.state?.data?.global?.offeringKind
    }

    $scope.isOfferingProduct = function() {
        return $scope?.state?.data?.global?.offeringKind == 'product'
    }

    $scope.changeViewModeCalendar = function() {
        $scope.state.view.mode = 'calendar'
        $rootScope.$broadcast('clearPosts')
        safeSetObject($scope, 'state.data.global.viewMode', 'calendar')

        api.updateProjectGlobalSingle($scope.inputs.project, {
            'viewMode': 'calendar'
        }).catch((err) => {
        })
    }

    $scope.changeViewModeList = function() {
        $scope.state.view.mode = 'list'
        $scope.loadPosts()
        safeSetObject($scope, 'state.data.global.viewMode', 'list')
        api.updateProjectGlobalSingle($scope.inputs.project, {
            'viewMode': 'list'
        }).catch((err) => {
        })
    }

    $scope.isViewModeCalendar = function() {
        return $scope.state.view.mode == 'calendar'
    }

    $scope.isViewModeList = function() {
        return $scope.state.view.mode == 'list'
    }

    $scope.isMainTabTheme = function() {
        return $scope.state.view.mainTab == 'theme'
    }

    $scope.isMainTabDashboard = function() {
        return $scope.state.view.mainTab == 'dashboard'
    }

    $scope.isMainTabCalendar = function() {
        return $scope.state.view.mainTab == 'calendar'
    }

    $scope.isMainTabCreate = function() {
        return $scope.state.view.mainTab == 'create'
    }

    $scope.isMainTabPersona = function() {
        return $scope.state.view.mainTab == 'persona'
    }

    $scope.isMainTabHelp = function() {
        return $scope.state.view.mainTab == 'help'
    }

    $scope.isMainTabCreateOrTheme = function() {
        return $scope.state.view.mainTab == 'create' || $scope.state.view.mainTab == 'theme'
    }

    $scope.isMainTabCreateOrPersona= function() {
        return $scope.state.view.mainTab == 'create' || $scope.state.view.mainTab == 'persona'
    }

    $scope.isMainTabCalendarOrTheme = function() {
        return $scope.state.view.mainTab == 'calendar' || $scope.state.view.mainTab == 'theme'
    }

    $scope.logout = function() {
        localStorage.removeItem('auth.token')
        localStorage.removeItem('auth.token.confirm');
        reloadLocation()
    }

    $scope.goToSupport = function() {
        let contactURL = _trans.support.url[language]
        window.open(contactURL, '_system')
    }

    function getContentLanguage() {
        if ($scope.state && $scope.state.data && $scope.state.data.global && $scope.state.data.global.config && $scope.state.data.global.config.language) {
            return $scope.state.data.global.config.language
        }
        return null
    }

    $scope.setContentLanguage = function(language) {
        if (!$scope.state.data.global) {
            $scope.state.data.global = {}
        }
        if (!$scope.state.data.global.config) {
            $scope.state.data.global.config = {}
        }
        $scope.state.data.global.config.language = language
    }

    $scope.getLanguageWithFallback = function(context, resultCb) {
        function cb(lang) {
            if (lang && validLangs.indexOf(lang) != -1) {
                resultCb(lang)
                return
            }
            resultCb(null)
        }
        const validLangs = [
            'en', 'zh', 'ja', 'de', 'hi', 'fr', 'it', 'pt', 'ko', 'ru', 'es', 'id', 'nl', 'ar', 'tr', 'pl', 'sv', 'th', 'no', 'fa', 'he', 'da', 'ms', 'fi', 'ur', 'bn', 'cs', 'ro', 'el', 'hu', 'kk', 'uk', 'sk', 'si', 'bg', 'be', 'sw', 'sl', 'lt', 'sr', 'hr', 'et', 'km', 'bs', 'lv', 'ps', 'ka', 'mn', 'sq', 'mk', 'hy', 'ky', 'tg', 'rw', 'ne', 'tk', 'ca', 'pa',
        ]

        let generationLanguage = getContentLanguage()
        if (generationLanguage) {
            cb(generationLanguage)
            return
        }
        function getFromUserLanguage() {
            let lang = null
            try {
                lang = navigator.language || navigator.userLanguage
                lang = lang.slice(0, 2).toLowerCase()
            } catch (e) {
            }
            return lang
        }
        // TODO - i18n
        // Callback for portuguese
        if (getFromUserLanguage() == 'pt') {
            cb('pt')
            return
        }
        if (location.host.indexOf('.com.br') != -1) {
            cb('pt')
            return
        }
        if (context && context.trim() != '') {
            api.detectLanguage({
                text: context
            }).then(function(response) {
                let data = response.data
                if (data.language) {
                    cb(data.language)
                } else {
                    generationLanguage = getFromUserLanguage()
                    cb(generationLanguage)
                }
            }).catch(function(err) {
                generationLanguage = getFromUserLanguage()
                cb(generationLanguage)
            })
        } else {
            generationLanguage = getFromUserLanguage()
            cb(generationLanguage)
        }
    }

    $scope.init = function() {
        console.log('Init ideas');
        $scope.loadInputs()
        if (!$scope.inputs.handle || $scope.inputs.handle.trim() === '') {
            let interval = setInterval(() => {
                let input = document.getElementById('social-handle')
                if (input) {
                    input.focus()
                    clearInterval(interval)
                }
            }, 100)
        }

        try {
            if (!isLoggedIn()) {
                // get param instagram from url
                let instagramParam = new URLSearchParams(window.location.search).get('instagram')
                if (instagramParam && instagramParam.trim() != '') {
                    $scope.inputs.handle = decodeURIComponent(instagramParam.toLowerCase().trim())
                    $scope.socialSubmit()
                }
            }
        } catch (e) {
            console.log('Error parsing url', e);
        }

        $rootScope.alreadyGenerated = localStorage.getItem('galilai.generation.complete')
    }

    $scope.initFonts = function() {

        let primary = $scope.state.data.theme.fonts.primary
        let secondary = $scope.state.data.theme.fonts.secondary

        let fontsToLoad = [primary, secondary]
        // Make unique
        fontsToLoad = Array.from(new Set(fontsToLoad))
        fontsService.waitForFonts(fontsToLoad, function() {
            function getFont(id) {
                if (!id) {
                    return null
                }

                let name = fontsService.getFontName(id)

                return {
                    label: name,
                    value: id
                }
            }
            let primaryFont = getFont($scope.state.data.theme.fonts.primary)
            let secondaryFont = getFont($scope.state.data.theme.fonts.secondary)

            let fonts = JSON.parse(JSON.stringify(DEFAULT_FONTS))
            fonts = fonts.filter(function(font) {
                return font.value != primaryFont.value && font.value != secondaryFont.value
            })

            // Add primary and secondary fonts to beginning
            if (primaryFont) {
                fonts.unshift(primaryFont)
            }
            if (primaryFont && secondaryFont && secondaryFont.value != primaryFont.value) {
                fonts.unshift(secondaryFont)
            }

            $scope.state.data.fonts = fonts
            $timeout(angular.noop)
        })
    }

    function ensurePath(obj, path) {
       return path.reduce((acc, key) => (acc[key] ??= {}), obj);
    }

    $scope.showUserInput = function(typeShow) {
        if (typeShow == 'no-profile' && isLoggedIn()) {
            $scope.hideInputs()
            $scope.changeMainTab('persona')
            ensurePath($scope, ['state', 'data', 'global', 'content', 'author']);
            $scope.state.data.global.content.author.handle = 'meuperfil'
            $scope.changeGlobal()
            return
        }
        if (typeShow == 'add-project') {
            $scope.inputs.profile = ''
            $scope.state.view.manualProject = true
            $scope.state.view.instagram = true
            $scope.state.view.input = true
            $scope.state.view.showInputs = true
        } else {
            $scope.state.view.manualProject = false
            $scope.state.view.instagram = false
            $scope.state.view.input = true
            $scope.state.view.showInputs = true
        }

        if (typeShow && typeShow == 'no-profile') {
            track('Editor Without Instagram')
        }
    }

    $scope.retryLogin = function() {
        reloadLocation()
    }

    $scope.loginWithPassword = function() {
        $scope.loginInputs.loading = true

        api.loginWithPassword({
            email: $scope.loginInputs.email,
            password: $scope.loginInputs.password
        }).then(function(response) {
            let data = response.data
            if (data.token) {
                localStorage.setItem('auth.token', data.token)
                showSuccess(gettext('success.generic'))
                reloadLocation(true)
            } else {
                showError(gettext('error.generic'))
            }
        })
        .catch(function() {
            showError(gettext('error.generic'))
        })
        .finally(function() {
            $timeout(() => {
                $scope.loginInputs.loading = false
            })
        })

    }

    $scope.login = function() {
        let initialData = null
        if ($scope.inputs.handle) {
            initialData = {
                meta: {
                    instagram: $scope.inputs.handle
                }
            }
        }
        checkLogin(function() {
            if (!isLoggedIn()) {
                return
            }
            $timeout(() => {
                window.location.reload()
            }, 500)
        }, true, initialData)
        track('Editor Login Click')
    }


    function buildSocialWithProjectInfo(project) {
        let defaultSocial = project?.data?.profile?.social || {}
        let authorData = project?.data?.global?.content?.author || {}
        let globalData = project?.data?.global || {}
        let profileData = project?.data?.profile || {}
        let newSocial = {
            handle: authorData.handle || defaultSocial.handle,
            name: authorData.name || defaultSocial.name,
            bio: profileData.context || defaultSocial.bio,
            image: authorData.image || defaultSocial.image,
            language: globalData?.config?.language || defaultSocial.language,
            area: globalData.area || defaultSocial.area,
            category: globalData.category || defaultSocial.category,
            profession: globalData.profession || defaultSocial.profession
        };
        return newSocial
    }

    function showOnboardingQuestions() {
        if (!$scope.inputs.project) {
            return
        }
        // Show onboarding
        let fieldsToCheck = [
            'category',
            'serviceType',
            'automation',
            'focus'
        ]
        let showOnboarding = false;
        let now = Date.now();

        for (let field of fieldsToCheck) {
            if (!$scope?.state?.view?.fullProject?.data?.global?.[field]) {
                showOnboarding = true;
                break;
            }
        }

        // only show once per day
        let lastOnboardingShow = safeGetStorage('galilai.onboarding.lastShow') || null;
        if (lastOnboardingShow) {
            let lastDate = parseInt(lastOnboardingShow);
            if (now - lastDate < 24 * 60 * 60 * 1000) {
                // TODO - remove
                showOnboarding = false;
            }
        }
        // Disable close modal
        if (showOnboarding) {
            $rootScope.waitForUserConfig(function(ready) {
                if (!ready) {
                    return
                }
                if ($rootScope.isCancelled()) {
                    return
                }
                safeSetStorage('galilai.onboarding.lastShow', now);
                let onboardingModal = angular.element('#onboarding-modal')
                if (onboardingModal) {
                    onboardingModal.modal({ backdrop: 'static', keyboard: false}).modal('show')
                    onboardingModal.on('hidden.bs.modal', function () {
                        $rootScope.pendingShowIntroSteps = true
                    })
                }
            })
            canShowUpdates = false
        }
    }

    $scope.loadProject = function(project) {
        $scope.state.view.fullProject = project
        $scope.inputs.project = project._id
        if (project.data && project.data.profile) {
            $scope.inputs.profile = project.data.profile.context
            $scope.inputs.social = buildSocialWithProjectInfo(project)
            $scope.inputs.handle = $scope.inputs?.social?.handle
            $scope.inputs.keywords = project.data.profile.keywords
            $scope.inputs.context = project.data.profile.ideas
            $scope.inputs.audience = project.data.profile.audience
            $scope.inputs.needs_audience = project.data.profile.needs_audience
            $scope.inputs.goals_audience = project.data.profile.goals_audience
        }

        if (project.data && project.data.global) {
            $scope.state.data.global = project.data.global
            $rootScope.global = project.data.global
        }

        if (!$scope.state.data.global) {
            $scope.state.data.global = {}
        }
        if (!$scope.state.data.global.config) {
            $scope.state.data.global.config = {}
        }
        if (!$scope.state.data.global.config.contextType) {
            $scope.state.data.global.config.contextType = DEFAULT_CONTEXT_TYPE
        }
        if (!$scope.state.data.global.config.datesCategory) {
            $scope.state.data.global.config.datesCategory = 'default'
        }

        if ($scope?.state?.data?.global?.viewMode && ENABLE_INITIAL_VIEWMODE) {
            $scope.state.view.mode = $scope.state.data.global.viewMode
        }
        $scope.saveInputs()
        $scope.processKeywords()

        let themeToApply = project.data && project.data.theme
        if (!themeToApply) {
            themeToApply = JSON.parse(JSON.stringify(BASE_THEME))
        }
        if (themeToApply) {
            $scope.state.data.theme = themeToApply
            $rootScope.theme = themeToApply
            $rootScope.$broadcast('themeChanged', themeToApply)
        }

        if (!$scope.inputs.keywords || $scope.inputs.keywords.length == 0) {
            $scope.getInitialKeywords(true)
        }

        $rootScope.$broadcast('projectLoaded', project)

        $scope.initFonts()

        $scope.processDefaultPalletes($scope.state.data.theme)
        $scope.loadTempEditing()

        // When there is no initial handle set NO_HANDLE
        if (!$scope?.state?.data?.global?.content?.author?.handle) {
            // Wait until !$rootScope.loading.calendar && $rootScope.started
            let interval = setInterval(function() {
                if (!$rootScope.loading.calendar && $rootScope.started) {
                    clearInterval(interval)
                    $scope.editProject()
                    $scope.showInstagramInput()
                    $scope.inputs.handle = ''
                }
            }, 200)
            pendingOnboarding = true
            canShowUpdates = false
        } else {
            showOnboardingQuestions()
        }

        $scope.onboarding.values = $scope?.state?.view?.fullProject?.data?.global?.onboarding || {}
        $scope.updateProgress(false);
    }

    $scope.getProjectName = function() {
        return $scope?.state?.view?.fullProject?.name?.replace(/@/g, '')
    }

    $scope.loadTempEditing = function() {
        $scope.tmpEditing = {
            fontSize: {},
            pallete: {}
        }

        const DEFAULTS = getBaseTheme().defaults
        const baseTheme = fullcopy($scope.state.data.theme)
        if (!$scope.state.data.theme.defaults) {
            $scope.state.data.theme.defaults = {}
        }
        const base = fullcopy($scope.state.data.theme.defaults)
        $scope.tmpEditing.fontSize = Object.assign({}, DEFAULTS, base)
        $scope.tmpEditing.pallete = Object.assign({}, baseTheme.pallete)
    }

    $scope.onChangeFontSize = function() {
        for (let key in $scope.tmpEditing.fontSize) {
            $scope.state.data.theme.defaults[key] = $scope.tmpEditing.fontSize[key]
        }

        $rootScope.$broadcast('themeChanged', $scope.state.data.theme)
        $scope.saveTheme($scope.state.data.theme)
    }

    $scope.onFontsHighlightChange = function() {
        $scope.saveTheme($scope.state.data.theme)
    }

    $scope.resetToDefault = function() {
        const DEFAULTS = getBaseTheme().defaults
        for (let key in DEFAULTS) {
            $scope.state.data.theme.defaults[key] = DEFAULTS[key]
        }
        $rootScope.$broadcast('themeChanged', $scope.state.data.theme)
        $scope.saveTheme($scope.state.data.theme)
        $scope.loadTempEditing()
    }

    $scope.processDefaultPalletes = function(theme) {
        if (!theme) {
            return
        }
        if (theme.colors || theme.palletes) {
            return
        }

        // Check for pallete and all three colors
        if (!theme.pallete || !theme.pallete.main || !theme.pallete.text || !theme.pallete.highlight) {
            return
        }
        let existingColors = new Set()
        existingColors.add(theme.pallete.main)
        existingColors.add(theme.pallete.text)
        existingColors.add(theme.pallete.highlight)
        existingColors = Array.from(existingColors)
        theme.colors = existingColors.map(function(color) {
            return {
                value: color,
            }
        })

        theme.palletes = [
            {
                main: theme.pallete.main,
                text: theme.pallete.text,
                highlight: theme.pallete.highlight,
            }
        ]

        $scope.state.data.theme = theme
        $scope.saveTheme(theme)
    }

    $scope.searchPosts = function() {
        $rootScope.loadingDesign()
        $scope.loadPosts()
        $rootScope.$broadcast('clearPosts')
    }

    $rootScope.$on('loadMorePosts', function(event, data) {
        $scope.loadPosts(true)
    })

    $scope.loadPosts = function (append = false) {
        if (!append) {
            $scope.pagination.page = 1
            $scope._postData = null
        }
        $rootScope.$emit('posts.pagination', {
            hasMore: true
        })
        function parsePosts(data) {

            let items = append && $scope._postData?.items ? [...$scope._postData.items] : []
            let images = append && $scope._postData?.images ? [...$scope._postData.images] : []
            let layouts = append && $scope._postData?.layouts ? [...$scope._postData.layouts] : []
            let overlays = append && $scope._postData?.overlays ? { ...$scope._postData.overlays } : {}
            let settings = append && $scope._postData?.theme?.settings ? { ...$scope._postData.theme.settings } : {}
            let extraInfo = append && $scope._postData?.extraInfo ? { ...$scope._postData.extraInfo } : {}
            let theme = $scope.state.data.theme || null
            let global = $scope.state.data.global || null
            let index = items.length

            data.posts = data.posts.filter(function (item) {
                return item.data && item.data.items && item.data.items.length > 0
            })

            let formats = ['post', 'reels', 'post']
            let allThemes = append && $scope._postData?.allThemes ? { ...$scope._postData.allThemes } : {}
            let startIndex = items.length

            data.posts.forEach(function (item, postIndex) {
                try {
                    let realIndex = startIndex + postIndex
                    let post = item.data;

                    // TASK [HP] Fix theme
                    if (post.theme && !theme) {
                        theme = post.theme
                    }
                    if (post.global && !global) {
                        global = post.global
                        $scope.state.data.global = global
                    }
                    if (post.items) {
                        items.push(post.items[0])
                        items[items.length - 1].id = index++
                        items[items.length - 1].serverId = item._id
                        items[items.length - 1]._post = {
                            meta: item.meta || null,
                        }

                        let published = item.publish && item.publish.items && item.publish.items.length > 0
                        let edited = item.meta && item.meta.edited
                        items[items.length - 1].edited = edited || published
                    }

                    // TASK [HP] - Review load posts from user
                    if (post.images) {
                        images.push(post.images[0])
                    } else {
                        images.push(null)
                    }

                    if (post.overlays && post.overlays[0]) {
                        overlays[realIndex] = post.overlays[0]
                    }

                    if (post.layouts) {
                        layouts.push(post.layouts[0])
                    } else {
                        layouts.push(null)
                    }

                    if (post.extraInfo) {
                        extraInfo[realIndex] = post.extraInfo
                    }

                    if (post?.theme?.settings && post.theme.settings[0]) {
                        settings[realIndex] = post.theme.settings[0]
                    }

                    let isScheduled = item.publish && item.publish.items && item.publish.items.length > 0
                    let isEditing = item.meta && item.meta.edited

                    if (isScheduled || isEditing) {
                        allThemes[realIndex] = post.theme
                    }

                    if (!extraInfo[realIndex]) {
                        extraInfo[realIndex] = {}
                    }

                    // Set format
                    if (!(isScheduled || isEditing) && !post.format) {
                        // Force reels on first one
                        if (realIndex == 0) {
                            extraInfo[realIndex].format = 'reels'
                        } else {
                            extraInfo[realIndex].format = chooseWithHash(formats, realIndex)
                        }
                    } else if (post.format) {
                        extraInfo[realIndex].format = post.format
                    } else {
                        extraInfo[realIndex].format = 'post'
                    }

                } catch (e) {
                    // TASK [HP] Send to sentry
                    logError({
                        message: 'Error parsing posts',
                        error: e
                    })
                }
            })

            theme.settings = settings

            let postData = {
                theme: theme,
                layouts: layouts,
                overlays: overlays,
                items: items,
                images: images,
                global: global,
                extraInfo: extraInfo,
                allThemes: allThemes,
            }

            $scope._postData = postData

            // TASK [HP] - Review load theme
            if (!$scope.state.data.theme && theme) {
                $scope.state.data.theme = theme
            }

            return postData
        }

        // Update view
        $scope.hideInputs()

        let typeLoading = 'initial'

        if (!$scope.inputs.project) {
            typeLoading = 'initial'
        } else {
            typeLoading = 'project'
        }

        if ($scope.isMainTabCalendar()) {
            typeLoading = 'projects-only'
        }

        if (!$scope.isMainTabCalendar()) {
            $rootScope.loadingDesign()
        }

        // Calendar on list mode
        if ($scope.isViewModeList()) {
            $rootScope.loadingDesign()
            typeLoading = 'project'
        }

        // TASK - Pass project id
        let inputParams = {
            type: typeLoading,
            project: $scope.inputs.project,
            filter: $scope.state.view.postsFilter,
            page: $scope.pagination.page,
            search: $scope.state.view.searchPosts,
        }

        api.getPosts(inputParams).then(function (response) {
            $timeout(() => {
                $rootScope.started = true;
                $rootScope.tab = 'ideas'

                let data = response.data

                if (data.projects) {
                    $scope.state.data.projects = data.projects
                }

                if (data.project) {
                    $scope.loadProject(data.project)
                }

                if (typeLoading == 'projects-only') {
                    return
                }

                if (data.posts.length) {
                    $rootScope.$emit('posts.pagination', {
                        hasMore: true
                    })
                    $scope.pagination.hasMore = true
                    $scope.pagination.page += 1
                    if (append && $scope.posts) {
                        $scope.posts = [...$scope.posts, ...data.posts]
                    } else {
                        $scope.posts = data.posts
                    }

                    let postData = parsePosts(data)

                    $rootScope.$broadcast('loadPost', postData)
                    $rootScope.$broadcast('loadedPosts', postData)

                } else {
                    $rootScope.$emit('posts.pagination', {
                        hasMore: false
                    })
                    $scope.pagination.hasMore = false
                    $rootScope.$broadcast('loadedPosts', null)

                    if ($scope.state.view.postsFilter == 'all' && $scope.isMainTabCreate()) {
                        $scope.showInputs()
                    }
                }
            })
        })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                $rootScope.loadedDesign()
            })
    }

    $scope.afterLogin = function() {
        $rootScope.alreadyGenerated = true
        $scope.state.view.loggedIn = true
        $scope.hideInputs()

        $scope.loadPosts()
    }

    let saveInterval = null
    $scope.onInputsChange = function() {
        if ($scope.state.view.creatingProject) {
            return
        }
        if ($scope.inputs.handle) {
            const regex = /instagram\.com\/([^/?]+)/i;
            const match = $scope.inputs.handle.match(regex);

            if (match && match[1]) {
                $scope.inputs.handle = match[1]
            }
        }
        // Check if there is .com
        if ($scope.inputs.handle && $scope.inputs.handle.indexOf('.com') != -1) {
            // Some users have social handle
            // showError(gettext('error.instagram.handle_invalid_no_email'))
            // return
        }
        // Remove @ from handle
        if ($scope.inputs.handle && $scope.inputs.handle.trim()[0] == '@') {
            $scope.inputs.handle = $scope.inputs.handle.trim().substr(1)
            showError(gettext('instagram.handle.at_removed'))
        }
        if ($scope.inputs.handle && $scope.inputs.handle.length > 50) {
            showError(gettext('instagram.handle.too_long'))
            $scope.inputs.handle = ''
            return
        }
        if ($scope.inputs.handle) {
            console.log('=> Handle changed', $scope.inputs.handle)
            $scope.inputs.handle = $scope.inputs.handle.trim().toLowerCase()
        }
        if (saveInterval) {
            $timeout.cancel(saveInterval)
        }
        saveInterval = $timeout(() => {
            $scope.saveInputs(true)
        }, 200)

        let alreadyTyped = localStorage.getItem('galilai.instagram.typed')
        if (!alreadyTyped && $scope.inputs.handle) {
            track('Editor Instagram Typed')
            localStorage.setItem('galilai.instagram.typed', true)
        }

        $scope.updateProjectName($scope.inputs.handle)
    }

    $scope.loadInputs = function() {
        if (!ENABLE_LOCAL_STORAGE_LOGGEDIN) {
            return
        }

        let instagram = localStorage.getItem('auth.user.instagram')
        let profile = localStorage.getItem('auth.user.profile')
        let social = localStorage.getItem('auth.user.social')
        let context = localStorage.getItem('auth.user.context')
        let keywords = localStorage.getItem('auth.user.keywords')
        let startedWithAreas = localStorage.getItem('auth.user.started_with_areas')

        if (instagram) {
            $scope.inputs.handle = instagram
        }
        if (profile && !startedWithAreas) {
            $scope.inputs.profile = profile
        }
        if (context) {
            $scope.inputs.context = context
        }
        if (keywords) {
            $scope.inputs.keywords = keywords
        }
        if (social) {
            try {
                $scope.inputs.social = JSON.parse(social)
            } catch (e) {
                console.log('Error parsing social', e);
            }
        }
        $scope.processKeywords()
    }

    let intervalSaveServer = null
    $scope.saveInputs = function(shouldClear=false) {
        if ($scope.state.view.creatingProject) {
            return
        }
        if (ENABLE_LOCAL_STORAGE_LOGGEDIN || !isLoggedIn()) {
            if ($scope.inputs.handle) {
                localStorage.setItem('auth.user.instagram', $scope.inputs.handle)
            }
            if ($scope.inputs.profile) {
                localStorage.setItem('auth.user.profile', $scope.inputs.profile)
            } else {
                if (shouldClear) {
                    localStorage.removeItem('auth.user.profile')
                }
            }
            if ($scope.inputs.social) {
                localStorage.setItem('auth.user.social', JSON.stringify($scope.inputs.social))
            }
            if ($scope.inputs.context) {
                localStorage.setItem('auth.user.context', $scope.inputs.context)
            } else {
                if (shouldClear) {
                    localStorage.removeItem('auth.user.context')
                }
            }
            if ($scope.inputs.keywords) {
                localStorage.setItem('auth.user.keywords', $scope.inputs.keywords)
            } else {
                if (shouldClear) {
                    localStorage.removeItem('auth.user.keywords')
                }
            }
            if ($scope.inputs.area) {
                localStorage.setItem('auth.user.area', $scope.inputs.area)
            } else {
                if (shouldClear) {
                    localStorage.removeItem('auth.user.area')
                }
            }
        }

        if (intervalSaveServer) {
            $timeout.cancel(intervalSaveServer)
        }
        intervalSaveServer = $timeout(() => {
            $scope.saveInputsServer()
        }, 400)
    }

    $scope.getInputsToSave = function() {
        let inputs = {
            handle: $scope.inputs.handle,
            profile: $scope.inputs.profile,
            social: $scope.inputs.social,
            context: $scope.inputs.context,
            keywords: $scope.inputs.keywords,
            audience: $scope.inputs.audience,
            needs_audience: $scope.inputs.needs_audience,
            goals_audience: $scope.inputs.goals_audience,
        }
        // Remove empty fields or undefined
        for (let key in inputs) {
            if (!inputs[key]) {
                delete inputs[key]
            }
        }
        return inputs
    }
    $scope.saveInputsServer = function() {
        if (!isLoggedIn()) {
            return
        }

        if (!$scope.inputs.project) {
            return
        }

        let inputs = $scope.getInputsToSave()
        // Compare with lastSavedConfig
        if (JSON.stringify(inputs) == $scope.state.data.lastSavedConfig) {
            console.log('=> No changes to save')
            return
        }

        $scope.state.data.lastSavedConfig = JSON.stringify(inputs)

        let profile = {
            context: $scope.inputs.profile,
            ideas: $scope.inputs.context,
            social: $scope.inputs.social,
            keywords: $scope.inputs.keywords,
            audience: $scope.inputs.audience,
            needs_audience: $scope.inputs.needs_audience,
            goals_audience: $scope.inputs.goals_audience,
        }

        api.updateProjectProfile($scope.inputs.project, profile)
        .then(function(response) {
            if (response?.data && pendingOnboarding && hasUpdatedInstagramContext) {
                pendingOnboarding = false
                hasUpdatedInstagramContext = false
                $scope.state.view.fullProject = response.data
                showOnboardingQuestions()
            }
        })
        .catch(function() {
            // TASK - No handling
        })
    }

    $scope.processKeywords = function() {
        if (!$scope.inputs.keywords) {
            $scope.state.data.keywords = []
            return
        }
        let text = $scope.inputs.keywords
        text = text.replace(/\./g, '')
        let keywords = text.split(',')
        keywords = keywords.map(function(keyword) {
            return keyword.trim()
        })
        $scope.state.data.keywords = keywords
    }

    $scope.showInstagramInput = function() {
        console.log('showInstagramInput');
        if ($scope.isMainTabTheme()) {
            $scope.changeMainTab('create', false)
        }
        $scope.state.view.instagram = true
        $scope.state.view.input = false
        $scope.state.view.showInputs = true
        $timeout(angular.noop)
    }

    $scope.removeProject = function() {
        if (!isLoggedIn()) {
            return
        }

        if (!$scope.inputs.project) {
            return
        }
        if ($scope.state.data.projects.length == 1) {
            showError(gettext('error.remove_project_last'))
            return
        }
        showConfirm(gettext('label.remove_project_confirm'), null, function(status) {
            if (status) {
                angular.noop()

                $scope.state.data.projects = $scope.state.data.projects.filter(function(project) {
                    return project._id != $scope.inputs.project
                })
                api.removeProject($scope.inputs.project).then(function() {
                    $scope.selectProject($scope.state.data.projects[0])
                    $scope.changeMainTab('calendar')
                })
                .catch(function() {
                    // TASK - No handling
                    console.log('Error removing project');
                })
            }
        })
    }

    $scope.removeAllPosts = function() {
        if (!isLoggedIn()) {
            return
        }

        if (!$scope.inputs.project) {
            return
        }
        showConfirm(gettext('label.remove_all_posts_confirm'), null, function(status) {
            if (status) {
                angular.noop()

                api.removeAllPosts($scope.inputs.project).then(function() {
                    $rootScope.$broadcast('calendarReload')
                    $scope.changeMainTab('calendar')
                })
                .catch(function() {
                    console.log('Error removing project');
                })
            }
        })
    }

    $scope.showPersona = function() {
        $scope.state.view.showPersona = true
        track('Editor Persona Show')
    }

    $scope.hidePersona = function() {
        $scope.state.view.showPersona = false
        track('Editor Persona Hide')
    }

    $scope.clearContext = function() {
        $scope.inputs.context = null
        track('Editor Clear Context')
        $scope.saveInputs()
    }

    $scope.showInputs = function() {
        $scope.state.view.showInputs = true
        if ($scope.inputs.handle && $scope.inputs.profile) {
            $scope.state.view.instagram = false
            $scope.state.view.input = true
        }
    }

    $scope.hideInputs = function() {
        $scope.state.view.manualProject = false
        $scope.state.view.showInputs = false
        $scope.state.view.creatingProject = false
        if ($scope.unifiedView && isLoggedIn()) {
            // This is called after load posts
            $scope.changeMainTab('calendar')
        }
    }

    function addGlobalParamsToInput(input) {
        let keys = [
            'area',
            'category',
            'profession',
        ]
        if ($scope.state && $scope.state.data && $scope.state.data.global) {
            let global = $scope.state.data.global
            keys.forEach(function(key) {
                if (global[key]) {
                    input.inputs[key] = global[key]
                }
            })
        }
    }

    $scope.stopGenerating = function(cb) {
        $timeout(function() {
            if (currentReader) {
                currentReader.cancel()
                $timeout(() => {
                    currentReader = null
                })
            }
            if (abortController) {
                if (!abortController.signal.aborted) {
                    abortController.abort()
                }
                abortController = null
            }
            if (intervalCheck) {
                clearTimeout(intervalCheck)
                intervalCheck = null
            }
            $scope.state.view.generating = false
            $rootScope.loadedDesign()
        })
    }

    // TODO - Externalize
    $scope.generateIdeasStream = function(input, cb) {
        let generateInterval = null
        console.log('=> Generate ideas stream', generateRetries)
        if ($scope.state.view.generating && generateRetries <= 0) {
            console.log('=> Stop generating due to retries')
            $scope.stopGenerating()

            if (cb && $scope.isMainTabCalendar()) {
                cb({message: 'errors.retries'}, null, true)
            } else if ($rootScope.postsAmount < MIN_AMOUNT_VERIFY) {
                showError(gettext('error.generating.content'))
            }
            return
        }
        if (abortController) {
            console.log('=> Clearing abort controller')
            if (!abortController.signal.aborted) {
                abortController.abort()
            }
            abortController = null
        }
        abortController = new AbortController()
        if ($rootScope.postsAmount == 0) {
            $rootScope.loadingDesign()
        }
        $scope.state.view.generating = true
        const currentSeed = Math.floor(Math.random() * 100000)
        input.inputs.seed = currentSeed
        input.inputs.uuid = safeGetStorage('galilai.uuid')

        addGlobalParamsToInput(input)

        let token = localStorage.getItem('auth.token');

        // Check generation
        let lastAmountGenerated = 0
        function checkGeneration() {
            if ($rootScope.postsAmount > lastAmountGenerated) {
                lastAmountGenerated = $rootScope.postsAmount
                intervalCheck = setTimeout(checkGeneration, CHECK_WAIT_POSTS)
                return
            }
            track('Editor Generate Timeout', {
                amount: $rootScope.postsAmount
            })
            finishGenerating('checkGenerating')
            // logError(new Error('Timeout generating posts'))
            if (generateInterval) {
                clearInterval(generateInterval)
            }
        }
        intervalCheck = setTimeout(checkGeneration, CHECK_WAIT_POSTS)

        // Finish generating
        function finishGenerating(finishReason, finishCb, shouldRetry) {
            console.log('=> Finish generating', finishReason, 'posts', $rootScope.postsAmount, 'shouldRetry', shouldRetry)
            $timeout(() => {
                if (intervalCheck) {
                    clearTimeout(intervalCheck)
                    intervalCheck = null
                }

                // Do not retry on message
                if (typeof shouldRetry != 'undefined' && !shouldRetry) {
                    if (currentReader) {
                        currentReader.cancel()
                        currentReader = null
                    }
                    finishCb()
                    return
                }
                // Retry generating
                console.log('=> Finish generating amount', $rootScope.postsAmount, $scope.state.view.generating)
                if ($rootScope.postsAmount < MIN_AMOUNT && $scope.state.view.generating) {
                    if (currentReader) {
                        currentReader.cancel()
                        currentReader = null
                    }
                    generateRetries -= 1
                    $scope.generateIdeasStream(input, cb)
                    track('Editor Generate Retry', {
                        amount: $rootScope.postsAmount
                    })
                    console.log('=> Retry generating', '# posts', $rootScope.postsAmount, 'retries left', generateRetries)
                    return
                } else if(finishCb) {
                    console.log('=> callback generating')
                    $scope.state.view.generating = false
                    if (generateInterval) {
                        clearInterval(generateInterval)
                    }
                    finishCb()
                }
            })
        }

        function generateWithJob() {
            if (generateInterval) {
                clearInterval(generateInterval)
            }
            api.generatePosts(input)
            .then((response) => {
                let jobId = response.data.job

                if (!jobId) {
                    finishGenerating('jobError', function() {
                        cb({message: 'errors.job'}, null, true)
                    })
                    return
                }

                let items = []
                generateInterval = setInterval(() => {
                    api.getJob(jobId, 'post').then(res => {
                        let job = res.data
                        if (!job || !job.data || !job.data.results || !job.data.results.length) {
                            if (job.status != 'pending') {
                                clearInterval(generateInterval)
                                finishGenerating('done', function() {
                                    cb(null, null, true)
                                })
                            }
                            return
                        }
                        let filteredItems = job.data.results.filter(item => items.indexOf(item) == -1)
                        for (let parseItem of filteredItems) {
                            $rootScope.loadedDesign()
                            items.push(parseItem)
                            cb(null, parseItem, false, null)
                        }

                        if (job.status == 'success') {
                            $rootScope.loadedDesign()
                            clearInterval(generateInterval)
                            finishGenerating('done', function() {
                                cb(null, null, true)
                            })
                        }
                    })
                    .catch((err) => {
                        $rootScope.loadedDesign()
                        clearInterval(generateInterval)
                        finishGenerating('fetchError', function() {
                            cb(err, null, true)
                        })
                        track('Editor Generate Error')
                        logError({
                            message: 'Error generating posts',
                            error: err
                        })
                    })
                }, JOB_INTERVAL_CHECK)
            })
            .catch((err) => {
                finishGenerating('fetchError', function() {
                    cb(err, null, true)
                })
                track('Editor Generate Error')
                logError({
                    message: 'Error generating posts',
                    error: err
                })
            })
        }

        if (USE_JOB_GENERATION) {
            generateWithJob()
            return
        }
        fetch(window.BASE_URL + '/api/creator/generate-stream/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/event-stream',
                'Authorization': 'Bearer ' + token,
                'Request-Id': window.RUN_ID,
            },
            body: JSON.stringify(input),
            signal: abortController.signal
        })
        .then((response) => {
            $rootScope.loadedDesign()
            // Ready and print each chunk of data (text ) to console
            const reader = response.body.getReader();
            currentReader = reader

            // Destroy the reader when the stream is done
            // TODO - Duplicated
            let readStream = (reader) => {
                return reader.read().then(({ done, value }) => {
                    if (done) {
                        finishGenerating('done', function() {
                            cb(null, null, true, reader)
                        })
                        return;
                    }
                    let textValue = new TextDecoder("utf-8").decode(value)
                    // Maybe split at data (so it can have multiple)
                    textValue = textValue.replace(/^data: /mg, '')
                    if (textValue.indexOf('{"error":true') != -1 || textValue.indexOf('{"error":{') != -1) {
                        let parsedError = {}
                        let shouldRetry = true
                        // Check for validations
                        try {
                            parsedError = JSON.parse(textValue)
                        } catch (e) {}
                        if (parsedError.message && gettext(parsedError.message) != '') {
                            shouldRetry = false
                        }
                        finishGenerating('apiError', function() {
                            cb(parsedError, null, true, reader)
                        }, shouldRetry)
                        try {
                            logError({
                                message: 'Error generating posts',
                            }, {
                                textValue: JSON.parse(textValue)
                            })
                        } catch (e) {
                            console.log(e)
                        }
                        return
                    }
                    try {
                        if (textValue.trim().indexOf('[DONE]') != -1) {
                            cb(null, null, true, reader)
                            return
                        } else {
                            let newText = textValue.replace('[DONE]', '')
                            const joinedText = newText.replace(/}{/g, '},{');
                            newText = newText.replace(/}{/g, '},{');
                            const jsonArrayResponse = `[${joinedText}]`;
                            const parsedItems = JSON.parse(jsonArrayResponse);
                            for (let parseItem of parsedItems) {
                                cb(null, parseItem, false, reader)
                            }
                        }
                    } catch (err) {
                        finishGenerating('parseError', function() {
                            cb(err, null, true, reader)
                        })
                        console.log('=> Parse error', textValue)
                        logError({
                            message: 'Error parsing posts',
                            error: err,
                        }, {
                            textValue: textValue
                        })
                        return
                    }
                    return readStream(reader);
                });
            }
            // Reader error event
            reader.onerror = (error) => {
                console.log('=> Reader error', error)
                finishGenerating('onError')
                track('Editor Generate Error')
                cb(error, null, true);
            }
            return readStream(reader);
        }).catch((err) => {
            // Check if it is abort error
            if (err && err.name == 'AbortError') {
                return
            }
            finishGenerating('fetchError', function() {
                cb(err, null, true)
            })
            track('Editor Generate Error')
            logError({
                message: 'Error generating posts',
                error: err
            })
        })

    }

    function isDefaultTheme(theme) {
        // Compare with default theme
        return BASE_THEME.pallete.main == theme?.pallete?.main &&
            BASE_THEME.pallete.text == theme?.pallete?.text &&
            BASE_THEME.pallete.highlight == theme?.pallete?.highlight
    }

    $scope.suggestTheme = function() {
        if (!$scope.inputs.profile || $scope.inputs.profile.trim() === '') {
            return
        }
        if ($scope.state?.data?.theme && !isDefaultTheme($scope.state?.data?.theme)) {
            return
        }
        // TODO - i18n - maybe?
        api.suggestTheme({
            context: $scope.inputs.profile,
            area: $scope.inputs.area,
            category: $scope.inputs.category,
            social: $scope.inputs.social,
        }).then(function(response) {
            $timeout(() => {
                let data = response.data
                $rootScope.$broadcast('themeChanged', data)
                $scope.state.data.theme = data

                $scope.saveTheme($scope.state.data.theme)
            })
        })
        .catch(function() {
            // TASK - No handling
        })
    }

    $scope.changePallete = function(pallete) {
        pallete = JSON.parse(JSON.stringify(pallete))
        let themePallete = JSON.parse(JSON.stringify(pallete))
        if (pallete.palletes) {
            $scope.selectedPallete = pallete
        }
        // TASK [HP] - Change pallete
        let theme = $scope.state.data.theme || $scope.posts[0].data.theme
        delete themePallete.palletes
        theme.pallete = themePallete

        $rootScope.$broadcast('themeChanged', theme)
        $scope.saveTheme(theme)

        track('Editor Pallete Click', {
            color: pallete.name
        })
    }

    $scope.onChangeColor = function() {
        $rootScope.$broadcast('themeChanged', $scope.state.data.theme)
        $scope.saveTheme($scope.state.data.theme)
        track('Editor Color Change')
    }

    $scope.onChangeFonts = function(source, value) {
        fontsService.load([value], function() {
            $rootScope.$broadcast('themeChanged', $scope.state.data.theme)
            $scope.saveTheme($scope.state.data.theme)
            track('Editor Font Change', {
                type: source,
                font: value
            })
            $timeout(angular.noop, 0)
        })
    }

    let timeoutSaveTheme = null
    $scope.saveTheme = function(theme) {
        if (!isLoggedIn() || !$scope?.inputs?.project) {
            return
        }

        if (timeoutSaveTheme) {
            $timeout.cancel(timeoutSaveTheme)
        }
        timeoutSaveTheme = $timeout(() => {
            api.updateTheme(theme, $scope.inputs.project).catch(function() {
                // TASK - No handling
            })
        }, 200)
    }

    $scope.showConfig = function() {
        $scope.state.view.customConfig = true
        $scope.state.view.showColors = false
        $scope.state.view.showFontSelection = true
        track('Editor Config Show')
    }

    $scope.hideConfig = function() {
        $scope.state.view.customConfig = false
        track('Editor Config Hide')
    }

    $scope.showColors = function() {
        $scope.state.view.customConfig = false
        $scope.state.view.showColors = true
        track('Editor Colors Show')
    }

    $scope.hideColors = function() {
        $scope.state.view.showColors = false
        track('Editor Colors Hide')
    }

    let intervalMessages = null
    function showLoadingMessages() {
        $scope.state.view.loading.next = true
        let index = 0
        $scope.state.view.profileMessage = profileMessages[language][index]
        intervalMessages = $interval(() => {
            if (index >= profileMessages.en.length) {
                $interval.cancel(intervalMessages)
                return
            }
            $scope.state.view.profileMessage = profileMessages[language][index]
            index += 1
            console.log('showLoadingMessages', $scope.state.view.profileMessage)
        }, INTERVAL_INSTAGRAM_MESSAGES)
    }
    function hideLoadingMessages() {
        if (intervalMessages) {
            $timeout(function(){
                $interval.cancel(intervalMessages)
                intervalMessages = null
                $scope.state.view.loading.next = false
            })
        }
    }

    function cleanInstagramHandle(handle) {
        if (!handle) {
            return ''
        }
        handle = handle.trim().toLowerCase()
        if (handle.indexOf('instagram.com/') != -1) {
            const regex = /instagram\.com\/([^/?]+)/i;
            const match = handle.match(regex);
            if (match && match[1]) {
                handle = match[1]
            }
        }
        if (handle[0] == '@') {
            handle = handle.substr(1)
        }
        return handle.trim()
    }

    $scope.forceAskingBusiness = function() {
        console.log('=> Force asking business', $scope.inputs?.handle);
        $scope.showUserInput('no-profile')
        $scope.state.view.detailedArea = true
        $rootScope.hideCustomAreas = true
        if (cleanInstagramHandle($scope.inputs.handle)) {
            if (!$scope.inputs) {
                $scope.inputs = {}
            }
            if (!$scope.inputs.social) {
                $scope.inputs.social = {}
            }

            $scope.inputs.social.handle = cleanInstagramHandle($scope.inputs.handle)
        }
    }

    $scope.getContextFromInstagram = function(updateViews=true) {
        console.log('getContextFromInstagram');

        if (updateViews) {
            track('Editor Instagram Click')
        }
        $scope.state.view.loading.next = true

        showLoadingMessages()
        if (!isLoggedIn()) {
            try {
                $scope.state.data.projects[0].name = $scope.inputs.handle
            } catch (e) {
                console.log(e)
            }
        }

        function getUTMParams() {
            try {
                let urlParams = new URLSearchParams(window.location.search);
                return {
                    source: urlParams.get('utm_source'),
                    medium: urlParams.get('utm_medium'),
                    campaign: urlParams.get('utm_campaign'),
                    content: urlParams.get('utm_content'),
                    term: urlParams.get('utm_term'),
                    fbclid: urlParams.get('fbclid'),
                    gclid: urlParams.get('gclid'),
                    referrer: document.referrer,
                    url: window.location.href,
                    userAgent: navigator.userAgent,
                }
            } catch (e) {
                return {}
            }
        }
        api.getContextFromInstagram({
            handle: $scope.inputs.handle,
            extras: getUTMParams(),
        }).then(function(response) {
            $timeout(() => {
                $scope.state.view.loading.next = false
                let data = JSON.parse(JSON.stringify(response.data))

                if (!isLoggedIn() && !data?.area) {
                    $scope.forceAskingBusiness()
                    return
                }

                if (data?.area) {
                    track('Editor Instagram Business', {
                        area: data.area,
                        category: data.category,
                        focus: data.focus,
                    })
                }

                $scope.inputs.profile = data.context
                $scope.inputs.social = data.social
                if (data.audience && !$scope.inputs.audience) {
                    $scope.inputs.audience = data.audience
                }
                if (data.language) {
                    $scope.setContentLanguage(data.language)
                }
                if (data.area) {
                    $scope.inputs.area = data.area
                }
                if (data.category) {
                    $scope.inputs.category = data.category
                }
                if (data.focus) {
                    $scope.inputs.focus = data.focus
                }
                let keysToAddGlobal = ['area', 'category', 'profession', 'focus']
                for (let key of keysToAddGlobal) {
                    if (data[key]) {
                        if (!$scope.state.data) {
                            $scope.state.data = {}
                        }
                        if (!$scope.state.data.global) {
                            $scope.state.data.global = {}
                        }
                        $scope.state.data.global[key] = data[key]
                    }
                }
                if (!$scope.inputs.keywords && data.keywords && data.keywords.length > 0) {
                    $scope.inputs.keywords = data.keywords
                } else {
                    $scope.getInitialKeywords()
                }
                hasUpdatedInstagramContext = true
                $scope.saveInputs()
                track('Editor Instagram Success')
                hideLoadingMessages()
                if (!updateViews) {
                    return
                }
                $timeout(() => {
                    $scope.showUserInput()
                    $scope.afterGenerateContext()
                })

                try {
                    if (updateViews) {
                        track('Editor Instagram Valid')
                    }
                } catch (err) {
                    console.log('gtag error', err)
                }
            })
        }).catch(function(err) {
            track('Editor Instagram Error')
            $timeout(() => {
                $scope.state.view.loading.next = false
            })
            if (isLoggedIn()) {
                showError(gettext('instagram.handle.error'))
            }
            hideLoadingMessages()

            if (!isLoggedIn()) {
                $scope.showUserInput('no-profile')
                $scope.state.view.detailedArea = true
                $rootScope.hideCustomAreas = true
                if (cleanInstagramHandle($scope.inputs.handle)) {
                    if (!$scope.inputs) {
                        $scope.inputs = {}
                    }
                    if (!$scope.inputs.social) {
                        $scope.inputs.social = {}
                    }

                    $scope.inputs.social.handle = cleanInstagramHandle($scope.inputs.handle)
                }
            }
        })
    }

    $scope.generateWithKeyword = function(keyword) {
        $scope.inputs.context = keyword
        $scope.generateIdeas()
        track('Editor Generate With Keyword', {
            keyword: keyword
        })
    }
    $scope.selectKeyword = function(keyword) {
        $scope.inputs.context = keyword
        $scope.onInputsChange()
        track('Editor Keyword Click', {
            keyword: keyword
        })
    }

    $scope.getInitialKeywords = function(force=false) {
        let keywords = localStorage.getItem('auth.user.keywords')
        if (keywords && !force) {
            return
        }
        if (!$scope.inputs.profile || $scope.inputs.profile.trim() === '') {
            return
        }
        // Check local storage
        api.keywordsFromProfile({
            profile: $scope.inputs.profile,
            language: getContentLanguage(),
        }).then(function(response) {
            let data = response.data
            $timeout(() => {
                $scope.inputs.keywords = data.keywords
                $scope.saveInputs()
                $scope.processKeywords()
            })
        }).catch(function() {
            // TASK - No handling
        })
    }
    $scope.refreshKeywords = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Refresh Keywords')) {
            return
        }
        $scope.state.view.loading.refreshKeywords = true
        api.keywordsFromProfile({
            profile: $scope.inputs.profile,
            language: getContentLanguage(),
        }).then(function(response) {
            $scope.state.view.loading.refreshKeywords = false
            let data = response.data
            $timeout(() => {
                $scope.inputs.keywords = data.keywords
                $scope.saveInputs()
                $scope.processKeywords()
            })
        }).catch(function(err) {
            $scope.state.view.loading.refreshKeywords = false
        })
    }

    // After generate context (instagram or manual)
    $scope.afterGenerateContext = function() {
        if ($scope.inputs.project) {
            $scope.afterChangeProjectSocial()
        }
        $scope.processKeywords()
        if (!$scope.inputs.profile || $scope.inputs.profile.trim() === '') {
            return
        }
        function generateInitialCalendar() {
            $rootScope.tab = 'ideas'
            $rootScope.started = true;
            $scope.state.view.showInputs = false;
            $scope.changeMainTab('dashboard')
        }
        if ($scope.inputs.project && ($scope.inputs.profile || $scope.inputs?.social?.bio)) {
            // Load full post
            topics.init({
                _id: $scope.inputs.project,
                data: {
                    profile: {
                        context: $scope.inputs?.profile,
                        social: $scope.inputs.social,
                    }
                }
            }, {
                language: getContentLanguage(),
            })
        }
        $scope.suggestTheme()

        if ($scope.unifiedView && isLoggedIn()) {
            generateInitialCalendar()
            return
        }

        let firstGeneration = localStorage.getItem('galilai.first.generation')
        if (!firstGeneration) {
            if (window.location.hostname != 'localhost') {
                localStorage.setItem('galilai.first.generation', true)
            }
            if (USE_CALENDAR_INITIAL) {
                generateInitialCalendar()
            } else {
                $scope.generateIdeas()
            }
        } else {
            if (USE_CALENDAR_INITIAL) {
                generateInitialCalendar()
            }
        }
    }

    $scope.saveItem = function(item) {
        if (!$scope.state.data.theme) {
            return
        }
        let uniqueId = null
        try {
            uniqueId = localStorage.getItem('galilai.uuid')
        } catch (e) {
            logError({
                message: 'Error getting unique id',
                error: e
            })
        }
        // Remove settings
        let themeToSave = JSON.parse(JSON.stringify($scope.state.data.theme))
        if (themeToSave.settings) {
            delete themeToSave.settings
        }
        let params = {
            item: item.content,
            theme: themeToSave,
            meta: {
                contextType: getContextType(),
                project: $scope.inputs.project,
                instagram: $scope.inputs.handle,
                uuid: uniqueId
            }
        }
        if (item?.content?.layout.startsWith(SMART_LAYOUTS_PREFIX)) {
            try {
                params.layout = layoutService.getExpandedLayout(item.content.layout)
                params.layout.label = item.content.layout
                delete params.item.fullLayout
            } catch (e) {
            }
        }
        api.getOrCreatePost(params).then(function(response) {
            let data = response.data
            $rootScope.$broadcast('itemChanged', {
                id: item.content.id,
                changes: {
                    serverId: data._id
                }
            })
        })
        .catch(function() {
            // TASK - No handling
        })
        if (isLoggedIn() && !$scope.inputs.project) {
            Sentry.captureException(new Error('Project not set'), {
                extra: {
                    inputs: $scope.inputs
                }
            })
        }
    }

    $scope.chooseArea = function(area) {
        safeSetStorage('auth.user.started_with_areas', true)
        $scope.inputs.area = area.value
        $scope.inputs.focus = MAP_AREAS_OBJECTIVE[area.value]
        $scope.inputs.profile = gettext('label.professional_area') + ' ' + area.label
        $scope.inputs.social = {
            handle: gettext('label.profile_handle'),
            name: gettext('label.profile_name')
        }
        try {
            localStorage.setItem('auth.user.area', $scope.inputs.area)
        } catch (e) {
            console.log(e)
        }
        $scope.generateIdeas()
    }

    function getContextType() {
        try {
            if ($scope.state.data.global && $scope.state.data.global.config && $scope.state.data.global.config.contextType) {
                return $scope.state.data.global.config.contextType
            }
        } catch (e) {
            logError('Error getting context type', e)
        }
        return DEFAULT_CONTEXT_TYPE
    }

    $scope.generateModal = function(source, params) {
        let profile = $scope.inputs.profile
        let context = '' // TODO - Review here
        let inputs = [profile, context].filter(function(input) {
            return input && input.trim() !== ''
        }).join('\n').trim()

        $scope.getLanguageWithFallback(inputs, function(generationLanguage) {
            if (generationLanguage) {
                $scope.setContentLanguage(generationLanguage)
            }
            let generateParams = {
                source: source,
                language: generationLanguage,
                theme: $scope.state.data.theme,
                project: $scope.inputs.project,
                handle: $scope.inputs.handle,
                profile: $scope.inputs.profile,
                needs: $scope.inputs.needs_audience,
                goals: $scope.inputs.goals_audience,
                audience: $scope.inputs.audience,
                social: $rootScope.getCurrentProjectInfo(),
                global: $scope.state.data.global,
                focus: $scope.inputs.focus,
            }
            if (params) {
                for (let key in params) {
                    generateParams[key] = params[key]
                }
            }
            $rootScope.$emit('generator.show', generateParams)
        })
    }

    $scope.showListViewGenerationModal = function() {
        if (!validateGeneration()) {
            return
        }
        $scope.generateModal('listView', {
            multiple: true,
        })
    }

    function validateGeneration() {
        if (localStorage.getItem('galilai.generation.complete') != null && !isLoggedIn()) {
            $rootScope.showTrial('Generated once but not logged in')
            return false
        }

        if (isLoggedIn() && localStorage.getItem('galilai.generation.complete') != null && !$rootScope.isCustomer(showModal = false)) {
            $rootScope.showTrialOrExpired('Generated once but not customer')
            return false
        }
        if (!$scope.inputs.profile || $scope.inputs.profile.trim() === '') {
            $rootScope.$broadcast('showPersona')
            showError(gettext('error.generate_empty_profile'))
            return false
        }
        return true
    }

    $scope.showCalendarGenerationModal = function(generationType, mode, params) {
        if (!validateGeneration()) {
            return
        }
        let fullParams = {
            multiple: generationType == 'single' ? false: true,
            mode: mode,
        }
        if (params) {
            for (let key in params) {
                fullParams[key] = params[key]
            }
        }
        $scope.generateModal('calendar', fullParams)
    }

    function addItem(newItem, itemResponse) {
        // TASK [HP] - Prepend bugs images
        itemResponse.content.id = itemsGenerated
        newItem.id = itemsGenerated
        itemsGenerated++

        $rootScope.$broadcast('itemAdded', newItem, prepend=false)

        let item = JSON.parse(JSON.stringify(itemResponse.content))
        if (!_GENERATE_IMAGES) {
            return
        }
        let relevantGlobals = ['area', 'category', 'profession', 'focus']
        try {
            if ($scope?.state?.data?.global) {
                for (let key of relevantGlobals) {
                    if ($scope.state.data.global[key]) {
                        item[key] = $scope.state.data.global[key]
                    }
                }
            }
        } catch (e) {}
        if (item.settings.dynamic) {
            api.generateDynamic(item).then(function(response) {
                let data = response.data
                let changes = {}
                // The card asked for a piece the server could not produce in time. It is hidden
                // rather than filled with something else — the layout it was given draws no text
                // of its own — and, just as importantly, it is not saved: the post never exists,
                // so there is nothing to carry into the account at sign-up.
                if (data.hide) {
                    $rootScope.$broadcast('itemChanged', {
                        id: item.id,
                        changes: {
                            hidden: true
                        }
                    })
                    return
                }
                // Three shapes come back here. A generated image is {url}. The demo card can
                // also answer with a video ({full, small, thumb}) — passed through whole,
                // because it is the object value that makes the renderer draw a <video> — or
                // with a plain url string for the visitor's own photo.
                if (data.image && data.image.full) {
                    changes.image = data.image
                    itemResponse.content.image = data.image
                } else if (data.image && data.image.url) {
                    changes.image = data.image.url
                    itemResponse.content.image = data.image.url
                } else if (typeof data.image == 'string' && data.image) {
                    changes.image = data.image
                    itemResponse.content.image = data.image
                } else if (item.settings.dynamic && item.settings.dynamic.image) {
                    changes.image = null
                    itemResponse.content.image = null
                }
                // Marks the card as a demo piece: it is what swaps the publish/edit/download
                // row for the single call to action. It has to reach itemResponse too, or the
                // saved post loses the mark and gets adopted at sign-up as if it were theirs.
                if (data.sample) {
                    changes.sample = data.sample
                    itemResponse.content.sample = data.sample
                }
                // Carried on the item itself, because settings.dynamic is meant to be dropped
                // once the image lands: without it the animator would pick this card up by the
                // index hash and try to animate a static piece.
                if (item.settings.dynamic && item.settings.dynamic.demoPost) {
                    changes.noAnimation = true
                    itemResponse.content.noAnimation = true
                }
                if (data.title) {
                    changes.title = data.title
                    itemResponse.content.title = data.title
                }
                if (typeof data.description != 'undefined') {
                    changes.description = data.description
                    itemResponse.content.description = data.description
                }
                $rootScope.$broadcast('itemChanged', {
                    id: item.id,
                    changes: changes
                })
                $timeout(() => {
                    $scope.saveItem(itemResponse)
                })
            }).catch(function(err) {
                // Same answer as a server-side `hide`, for the same reason: this card is pinned
                // to a layout that draws no text, so an empty one is not a card with a missing
                // image, it is a blank rectangle. Not saved either — a demo that failed should
                // not follow the visitor into their account.
                if (item.settings.dynamic && item.settings.dynamic.demoPost) {
                    $rootScope.$broadcast('itemChanged', {
                        id: item.id,
                        changes: {
                            hidden: true
                        }
                    })
                    return
                }
                if (item.settings.dynamic && item.settings.dynamic.image) {
                    itemResponse.content.image = null
                    $rootScope.$broadcast('itemChanged', {
                        id: item.id,
                        changes: {
                            image: null
                        }
                    })
                }
                $timeout(() => {
                    $scope.saveItem(itemResponse)
                })
            })
        } else {
            $scope.saveItem(itemResponse)
        }
    }

    function addNewItemWithDynamic(response) {
        let itemResponse = JSON.parse(JSON.stringify(response))
        let newItem = response.content

        if (newItem.fullLayout && newItem.layout) {
            layoutService.addDynamicLayout({
                data: newItem.fullLayout,
                id: newItem.layout,
            })
            .finally(function() {
                addItem(newItem, itemResponse)
            })
        } else {
            addItem(newItem, itemResponse)
        }
    }

    $scope.generateIdeas = function() {
        if (!validateGeneration()) {
            return
        }
        // Try to suggest theme if not set
        $scope.suggestTheme()
        try {
            // Generate ideas
            track('Editor Generate Ideas')
        } catch (err) {
            console.log(err)
        }

        $rootScope.tab = 'ideas'
        $rootScope.started = true;
        $scope.state.view.showInputs = false;

        let profile = $scope.inputs.profile
        let context = $scope.inputs.context

        $rootScope.$broadcast('clearPosts')
        $scope.saveInputs()

        itemsGenerated = 0

        function generationCallback(err, response, done, reader) {
            currentReader = reader;
            if (err) {
                // TASK [HP] - Test error handling
                console.log('=> Error generating', err)
                if ($rootScope.postsAmount < MIN_AMOUNT) {
                    showError(gettext('error.generating.content'))
                }
                $scope.stopGenerating()
                return
            }
            if (done) {
                track('Editor Generate Finished', {
                    amount: itemsGenerated
                })
                return
            }
            if (itemsGenerated == 0) {
                track('Editor Generate Success')
            }
            if (window.location.hostname != 'localhost') {
                localStorage.setItem('galilai.generation.complete', true)
            }
            $rootScope.alreadyGenerated = true

            addNewItemWithDynamic(response)
        }

        generateRetries = MAX_RETRIES
        $rootScope.postsAmount = 0

        $scope.state.view.postsFilter = 'all'

        let inputs = [profile, context].filter(function(input) {
            return input && input.trim() !== ''
        }).join('\n').trim()

        $scope.getLanguageWithFallback(inputs, function(generationLanguage) {
            if (generationLanguage) {
                $scope.setContentLanguage(generationLanguage)
            }

            // Start generation
            $scope.generateIdeasStream({
                inputs: {
                    userMedias: $scope.state.data.selectedMedias,
                    language: generationLanguage,
                    profile: profile,
                    context: context,
                    contextType: getContextType(),
                    contextualized: true,
                    pipeline: true,
                    multiple: true,
                    objective: $scope.inputs.focus,
                    area: $scope.inputs.area,
                    // The leaf niche, sent alongside the area so demo samples can be matched
                    // on it before falling back to the broader one
                    category: $scope.inputs.category,
                    needs: $scope.inputs.needs_audience,
                    goals: $scope.inputs.goals_audience,
                    audience: $scope.inputs.audience,
                    // One extra for the logged-out demo: the first card generated becomes
                    // the one that shows video, so without this the visitor would trade a
                    // personalised post for it instead of gaining one.
                    amount: isLoggedIn() ? AMOUNT_PER_GENERATION : AMOUNT_PER_GENERATION + 1,
                },
                social: $rootScope.getCurrentProjectInfo(),
            }, generationCallback)
        })
    }

    $scope.removeWatermark = function() {
        delete $scope.state.data.global.content.author.logo.url
        $scope.state.data.global.content.author.logo.enabled = false

        $scope.changeGlobal()
    }

    $scope.uploadLogo = function(file) {
        if (!$rootScope.isCustomer(showModal = true, source='Upload Logo')) {
            return
        }
        if (!file) {
            showError(gettext('error.invalid.image'))
            return;
        }

        var formData = new FormData();
        formData.append('image', file);
        formData.append('name', $scope.inputs.project || $scope.inputs.handle)

        let token = localStorage.getItem('auth.token');

        $scope.state.view.imageUploading = true
        $http({
          method: 'POST',
          url: window.BASE_URL + '/api/logo/upload',
          data: formData,
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        })
        .then(function(response) {
            $scope.state.view.imageUploading = false
            let logoURL = response.data.url

            if (!$scope.state.data.global) {
                $scope.state.data.global = {}
            }
            if (!$scope.state.data.global.content) {
                $scope.state.data.global.content = {}
            }
            if (!$scope.state.data.global.content.author) {
                $scope.state.data.global.content.author = {}
            }
            if (!$scope.state.data.global.content.author.logo) {
                $scope.state.data.global.content.author.logo = {}
            }
            $scope.state.data.global.content.author.logo.url = logoURL + '?v=' + new Date().getTime()
            $scope.state.data.global.content.author.logo.enabled = true
            if (!$scope.state.data.global.content.author.logo.mode) {
                $scope.state.data.global.content.author.logo.mode = 'watermark'
            }
            if (!$scope.state.data.global.content.author.logo.size) {
                $scope.state.data.global.content.author.logo.size = 'medium'
            }

            $scope.changeGlobal()
        })
        .catch(function(error) {
            $scope.state.view.imageUploading = false
            showError(gettext('error.invalid.image'))
        });
    }

    $scope.uploadSocialLogo = function(file) {
        if (!$rootScope.isCustomer(showModal = true, source='Upload Social Logo')) {
            return
        }
        if (!file) {
            showError(gettext('error.invalid.image'))
            return;
        }

        var formData = new FormData();
        formData.append('image', file);
        formData.append('name', $scope.inputs.project || $scope.inputs.handle)

        let token = localStorage.getItem('auth.token');

        $scope.state.view.imageUploading = true
        $http({
          method: 'POST',
          url: window.BASE_URL + '/api/image/social/upload',
          data: formData,
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        })
        .then(function(response) {
            $scope.state.view.imageUploading = false
            let logoURL = response.data.url

            if (!$scope.state.data.global) {
                $scope.state.data.global = {}
            }
            if (!$scope.state.data.global.content) {
                $scope.state.data.global.content = {}
            }
            if (!$scope.state.data.global.content.author) {
                $scope.state.data.global.content.author = {}
            }
            $scope.state.data.global.content.author.image = logoURL + '?v=' + new Date().getTime()
            $scope.changeGlobal()

            console.log('=> Logo uploaded', logoURL)
        })
        .catch(function(error) {
            console.log('=> Error uploading logo', error)
            $scope.state.view.imageUploading = false
            showError(gettext('error.invalid.image'))
        });
    }

    $scope.changeContextType = function(type, $event) {
        if (!$scope.state.data.global) {
            $scope.state.data.global = {}
        }
        if (!$scope.state.data.global.config) {
            $scope.state.data.global.config = {}
        }
        $scope.state.data.global.config.contextType = type

        $scope.changeGlobal()
        $event.target.blur()
    }

    let intervalSaveGlobal = null
    $scope.changeGlobal = function() {
        $rootScope.$broadcast('globalChanged', $scope.state.data.global)
        $rootScope.global = $scope.state.data.global
        if (intervalSaveGlobal) {
            $timeout.cancel(intervalSaveGlobal)
        }
        intervalSaveGlobal = $timeout(() => {
            api.updateProjectGlobal($scope.inputs.project, $scope.state.data.global)
            .catch(function() {
                // TASK - No handling
            })
        }, 300)

        if ($scope.state.data && $scope.state.data.global && $scope.state.data.global.content && $scope.state.data.global.content.author) {
            $scope.updateProjectName($scope.state.data.global.content.author.handle)
        }
    }

    // After fill instagram
    $scope.socialSubmit = function() {
        try {
            if (window.location.hostname == 'localhost' && safeGetStorage('demo.accounts')) {
                let randomAccounts = JSON.parse(safeGetStorage('demo.accounts'))
                let indexDemo = safeGetStorage('demo.accounts.index') || 0
                indexDemo = parseInt(indexDemo, 10)
                let randomAccount = randomAccounts[indexDemo % randomAccounts.length]
                indexDemo += 1
                safeSetStorage('demo.accounts.index', indexDemo)
                $scope.inputs.handle = randomAccount
            }
        } catch (e) {
        }
        // Check experiment
        if ($scope.state.view.detailedArea && $scope.inputs.profile && $scope.state.view.showAreas && !$scope.inputs.handle) {
            safeSetStorage('auth.user.started_with_areas', true)
            $scope.generateIdeas()
            return
        }
        if (!$scope.state.view.creatingProject) {
            $scope.getContextFromInstagram()
        } else {
            $scope.createProject()
        }
    }

    $scope.editProject = function(event) {
        if (event) {
            event.stopPropagation()
        }
        $scope.changeMainTab('theme')
        $scope.changeConfigTab('profile')
    }

    $scope.selectProject = function(project) {
        if ($rootScope.loading.calendar) {
            return
        }
        if (!project || !project._id) {
            return
        }
        console.log('Select project', project)
        $timeout(function() {
            $rootScope.$broadcast('clearPosts')
            $scope.inputs.project = project._id
            $scope.inputs.handle = project.name
            $scope.inputs.profile = ''
            $scope.inputs.keywords = ''

            $scope.loadPosts()
            track('Editor Project Click', {
                project: project._id,
                handle: project.handle,
            })
        })
    }

    $scope.addProject = function() {
        track('Editor Add Project Click')

        $scope.state.view.manualProject = false
        let maxCount = $rootScope.getTotalSocialAccounts()
        let currentCount = $scope.state.data.projects.length
        if (currentCount >= maxCount) {
            if ($rootScope.IAPEnabled()) {
                showConfirm(gettext('label.feature_contact_support'), null, function(status) {
                    if (status) {
                        $scope.goToSupport()
                    }
                })
                return
            }
            $rootScope.showUpgrade('Max projects reached')
            return
        }
        $scope.state.view.previousTabIsCalendar = $scope.isMainTabCalendar()
        $scope.changeMainTab('create', false)
        $scope.state.view.creatingProject = true
        $scope.state.data.previousInputs = JSON.parse(JSON.stringify($scope.inputs))
        $scope.inputs.handle = ''
        $scope.showInstagramInput()
    }

    $scope.updateProjectName = function(name) {
        if (!$scope.inputs.project) {
            return
        }
        let project = $scope.state.data.projects.find(function(project) {
            return project._id == $scope.inputs.project
        })
        let projectIndex = $scope.state.data.projects.findIndex(function(project) {
            return project._id == $scope.inputs.project
        })
        if (project) {
            if (!name || name.trim() === '') {
                name = gettext('label.project') + ' '+ (projectIndex + 1)
            }
            project.name = name
        }
    }
    $scope.afterChangeProjectSocial = function() {
        $scope.updateProjectName($scope.inputs.handle)

        if ($scope.inputs.social) {
            // Update global
            if (!$scope.state.data.global) {
                $scope.state.data.global = {}
            }
            if (!$scope.state.data.global.content) {
                $scope.state.data.global.content = {}
            }
            if (!$scope.state.data.global.content.author) {
                $scope.state.data.global.content.author = {}
            }
            $scope.state.data.global.content.author.handle = $scope.inputs.handle
            $scope.state.data.global.content.author.name = $scope.inputs.social.name
            $scope.state.data.global.content.author.image = $scope.inputs.social.image

            api.updateProjectGlobal($scope.inputs.project, $scope.state.data.global)
            .catch(function() {
                // TASK - No handling
            })

            $rootScope.$broadcast('globalChanged', $scope.state.data.global)
        }
    }

    $scope.createProject = function() {
        showLoadingMessages()
        let params = {
            handle: $scope.inputs.handle,
        }
        if ($scope.state.view.manualProject) {
            params.manual = true
            params.profile = $scope.inputs.profile
            params.name = $scope.inputs.name

            if (!params.profile || params.profile.trim() === '') {
                showError(gettext('error.generate_empty_profile'))
                hideLoadingMessages()
                return
            }
        }

        api.createProject(params).then(function(response) {
            $timeout(() => {
                $scope.state.view.creatingProject = false
                let project = JSON.parse(JSON.stringify(response.data))
                $scope.loadProject(project)
                $scope.showInputs()
                $scope.state.data.projects.push(project)

                if (USE_CALENDAR_INITIAL && $scope.state.view.previousTabIsCalendar || ($scope.unifiedView && isLoggedIn())) {
                    $scope.changeMainTab('calendar')
                    $scope.changeViewModeCalendar()
                    if (GENERATE_POSTS_AFTER_ADDING_PROJECT) {
                        $rootScope.$emit('generateInitialCalendar')
                    }
                } else {
                    $scope.generateIdeas()
                }
            })
        })
        .catch(function(err) {
            showError(gettext('error.project.create'))
            logError({
                message: 'Error creating project',
                error: err
            }, {
                handle: $scope.inputs.handle
            })
        })
        .finally(function() {
            $timeout(() => {
                $scope.state.view.creatingProject = false
                $scope.hideInputs()
                hideLoadingMessages()
            })
        })
    }

    $scope.generateAudienceNeeds = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Generate Audience Needs')) {
            return
        }
        if (!$scope.inputs.audience) {
            return
        }
        $scope.loadingNeeds = true
        api.getAudienceNeeds({
            audience: $scope.inputs.audience,
            profile: $scope.inputs.profile,
            language: getContentLanguage(),
        }).then(function(response) {
            let data = response.data
            $timeout(() => {
                $scope.inputs.needs_audience = data.needs
                $scope.saveInputs()
            })
        })
        .catch(function() {
            // TASK - No handling
        })
        .finally(function() {
            $timeout(() => {
                $scope.loadingNeeds = false
            })
        })
        track('Editor Generate Needs')
    }

    $scope.generateAudienceGoals = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Generate Audience Goals')) {
            return
        }
        if (!$scope.inputs.audience) {
            return
        }
        $scope.loadingGoals = true
        api.getAudienceGoals({
            audience: $scope.inputs.audience,
            profile: $scope.inputs.profile,
            language: getContentLanguage(),
        }).then(function(response) {
            let data = response.data
            $timeout(() => {
                $scope.inputs.goals_audience = data.goals
                $scope.saveInputs()
            })
        })
        .catch(function() {
            // TASK - No handling
        })
        .finally(function() {
            $timeout(() => {
                $scope.loadingGoals = false
            })
        })
        track('Editor Generate Goals')
    }

    $scope.generateAudience = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Generate Audience')) {
            return
        }
        if (!$scope.inputs.profile) {
            return
        }
        $scope.loadingAudience = true
        api.getAudience({
            profile: $scope.inputs.profile,
            language: getContentLanguage(),
        }).then(function(response) {
            let data = response.data
            $timeout(() => {
                $scope.inputs.audience = data.audience
                $scope.saveInputs()
            })
        })
        .catch(function() {
            // TASK - No handling
        })
        .finally(function() {
            $timeout(() => {
                $scope.loadingAudience = false
            })
        })
        track('Editor Generate Audience')
    }

    $scope.filterPosts = function(type) {
        track('Editor Filter Posts', {
            type: type
        })
        if (!$rootScope.isCustomer(showModal=false) && type == 'editing') {
            $rootScope.showUpgrade('Edit Item')
            return
        }
        if (!$rootScope.isProCustomer() && type == 'published') {
            $rootScope.showUpgrade('Publish Post Directly')
            return
        }
        if (!$rootScope.isProCustomer() && type == 'scheduled') {
            $rootScope.showUpgrade('Schedule Posts')
            return
        }
        $rootScope.$broadcast('clearPosts')
        $scope.state.view.postsFilter = type
        $scope.loadPosts()
    }

    $rootScope.$on('media.selected', function(event, medias, source) {
        if (source && source.origin != 'ideas') {
            return
        }
        if (source.name == 'image') {
            $scope.state.data.selectedMedias = medias
            track("Editor Selected Custom Media")
        }
        if (source.name == 'font') {
            let fontKey = medias[0].url.split('/').pop()
            let fontName = medias[0].name

            if ($scope.state.data.fonts.filter(font => font.value == fontKey).length == 0) {
                $scope.state.data.fonts.unshift({
                    label: fontName,
                    value: fontKey
                })
            }
            $scope.state.data.theme.fonts[source.kind] = fontKey
            $rootScope.$broadcast('themeChanged', $scope.state.data.theme)
            $scope.saveTheme($scope.state.data.theme)
            $scope.initFonts()
        }
    })

    $scope.selectImage = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Use my medias')) {
            return
        }
        modalElement = angular.element('#images-modal');
        if (modalElement) {
            modalElement.modal("show");

            $rootScope.$broadcast('media.show', {
                projectId: $scope.inputs.project,
                source: {
                    name: 'image',
                    origin: 'ideas',
                },
                kind: 'image',
            })
        }
        track("Editor Open Custom Media")
    }

    $scope.showMediaSelector = function(source, kind) {
        modalElement = angular.element('#images-modal');
        if (modalElement) {
            modalElement.modal('show')
            modalElement.css('z-index', 100000)

            if (typeof source == 'string') {
                source = {
                    name: source,
                }
            }
            source.origin = 'ideas'

            $rootScope.$broadcast('media.show', {
                source: source,
                projectId: $scope.inputs.project,
                kind: kind ? kind : 'image',
            })
        }
    }

    $scope.selectCustomFont = function(kind) {
        if (!$rootScope.isCustomer(showModal = true, source='Custom Fonts')) {
            return
        }
        $scope.showMediaSelector({
            origin: 'ideas',
            name: 'font',
            kind: kind
        }, 'font')
    }

    $scope.deselectImage = function(image) {
        $scope.state.data.selectedMedias = $scope.state.data.selectedMedias.filter(function(media) {
            return media.url != image.url
        })
        if ($scope.state.data.selectedMedias.length == 0) {
            $scope.state.data.selectedMedias = null
        }
    }

    $scope.startEmpty = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Create Scratch')) {
            return
        }
        let uniqueId = null
        try {
            uniqueId = localStorage.getItem('galilai.uuid')
        } catch (e) {
            logError({
                message: 'Error getting unique id',
                error: e
            })
        }
        let texts = [
            {
                title: gettext('scratch.post1.title'),
                description: gettext('scratch.post1.description'),
            },
            {
                title: gettext('scratch.post2.title'),
            },
            {
                title: gettext('scratch.post3.title'),
            },
            {
                title: gettext('scratch.post4.title'),
            },
            {
                title: gettext('scratch.post5.title'),
            },
        ]

        let author = null
        if ($scope.state.data.global && $scope.state.data.global.content && $scope.state.data.global.content.author) {
            author = $scope.state.data.global.content.author
        }
        function convertTextToItem(text, index) {
            let item = {
                id: index,
                handle: $scope.inputs.handle,
                title: text.title,
            }
            if (author) {
                item.author = author
            }
            if (text.description) {
                item.description = text.description
            }
            return item
        }

        // Remove settings
        let theme = JSON.parse(JSON.stringify($scope.state.data.theme))
        delete theme.settings

        let newPost = {
            item: texts.map(convertTextToItem),
            theme: theme,
            meta: {
                scratch: true,
                project: $scope.inputs.project,
                instagram: $scope.inputs.handle,
                uuid: uniqueId,
                calendar: {
                    date: new Date(),
                }
            }
        }
        api.getOrCreatePost(newPost, 'scratch').then(function(res) {
            let postUrl = '?id=' + res.data._id
            if (IS_APP) {
                postUrl += '&embed=true'
                $rootScope.$emit('openEditModal', {url: postUrl})
            } else {
                window.open(location.pathname + postUrl, '_blank')
            }
        })
        .catch(function(err) {
            showError(gettext('error.creating_scratch'))
        })

        track('Editor Create Scratch')
    }

    $scope.changeConfigTab = function(tab) {
        $scope.state.view.configTab = tab
        track('Editor Config Tab', {
            tab: tab
        })
    }

    $scope.showHelp = function() {
        if ($scope.state.view.portal) {
            return
        }
        // Ignore for testing apps
        if ($rootScope.startWithLogin) {
            return
        }
        api.config({}, {
            portal: true
        }).then(function(response) {
            let data = response.data
            $timeout(() => {
                $scope.state.view.portal = data.billing.portal
            })
        })
        .catch(function() {
            // TASK - No handling
        })
    }

    $scope.showHelpModal = function() {
        $rootScope.$broadcast('help.show', {
            group: 'getting-started'
        });
    }

    $scope.userChangeMainTab = function(tab) {
        $scope.changeMainTab(tab)

        if ($rootScope.pendingShowIntroSteps) {
            $rootScope.$broadcast('onboarding.doAction', {id: 'main-overview'})
            $rootScope.pendingShowIntroSteps = false
        }
    }

    $scope.changeMainTab = function(tab, shouldLoadPosts) {
        if ($rootScope.loading.calendar || !$rootScope.started) {
            return
        }
        $scope.state.view.mainTab = tab

        // TODO - Improve - no need to reload all the time and clear all the time
        if (tab == 'create') {
            if (typeof shouldLoadPosts === 'undefined' || shouldLoadPosts) {
                $scope.loadPosts()
            }
            $scope.hideConfig()
            $scope.hidePersona()
        } else if (tab == 'calendar') {
            if ($scope.isViewModeCalendar()) {
                $rootScope.$broadcast('clearPosts')
            }
        } else if (tab == 'theme') {
            $scope.showConfig()
        } else if (tab == 'persona') {
            $scope.showConfig()
            $scope.showPersona()
        } else if (tab == 'help') {
            $scope.showHelp()
        }

        track('Editor Main Tab', {
            tab: tab
        })
    }

})
